<template>
  <el-dialog 
    :title="getDialogTitle" 
    :visible.sync="dialogVisible" 
    width="88%" 
    :close-on-click-modal="false"
    :before-close="handleClose" 
    top="2vh" 
    custom-class="addxyk-dialog"
  >
    <div class="dialog-container">
      <!-- 上部分：采购信息 -->
      <div class="purchase-info-section">
        <h3 class="section-title">采购信息</h3>
        <el-form 
          ref="purchaseForm" 
          :model="purchaseForm" 
          :rules="purchaseRules" 
          label-width="120px" 
          size="mini"
        >
          <el-row :gutter="20">
            <!-- 出库药库 -->
            <el-col :span="8">
              <el-form-item label="出库药库：" prop="warehouseId">
                <el-select 
                  v-model="purchaseForm.warehouseId" 
                  placeholder="请选择出库药库" 
                  clearable
                  style="width: 100%"
                  @change="handleWarehouseChange"
                  :disabled="true"
                  size="mini"
                >
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 业务日期（禁用状态默认当前日期） -->
            <el-col :span="8">
              <el-form-item label="业务日期：" prop="businessDate">
                <el-date-picker
                  v-model="purchaseForm.businessDate"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :disabled="true"
                  size="mini"
                />
              </el-form-item>
            </el-col>
            
            <!-- 出库科室 -->
            <el-col :span="8">
              <el-form-item label="出库科室：" prop="deptId">
                <el-select
                  v-model="purchaseForm.deptId"
                  placeholder="请选择出库科室"
                  clearable
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                >
                  <el-option
                    v-for="item in deptOptions"
                    :key="item.id"
                    :label="item.deptName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <!-- 供货单位 + 供应商号码 -->
            <el-col :span="8">
              <el-form-item label="供货单位：" prop="supplierId">
                <div class="supplier-container">
                  <el-select
                    v-model="purchaseForm.supplierId"
                    placeholder="请选择供货单位"
                    clearable
                    style="flex: 1"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                    @change="handleSupplierChange"
                    size="mini"
                  >
                    <el-option
                      v-for="item in supplierOptions"
                      :key="item.id"
                      :label="item.supplierName"
                      :value="item.id"
                    />
                  </el-select>
                  <el-input
                    v-model="purchaseForm.supplierNo"
                    placeholder="供应商号码"
                    style="width: 150px; margin-left: 10px"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                    size="mini"
                  />
                </div>
              </el-form-item>
            </el-col>
            
			<!-- 出库方式 -->
			<el-col :span="6">
			  <el-form-item label="出库方式：" prop="outTypeId">
			    <el-select
			      v-model="purchaseForm.outTypeId"
			      placeholder="请选择出库方式"
			      clearable
			      style="width: 100%"
			      :disabled="currentMode !== 'add' && currentMode !== 'edit'"
			      size="mini"
			    >
			      <el-option
			        v-for="item in outTypeOptions"
			        :key="item.id"
			        :label="item.name"
			        :value="item.id"
			      />
			    </el-select>
			  </el-form-item>
			</el-col>
			
            <!-- 备注 -->
            <el-col :span="10">
              <el-form-item label="备注：" prop="remarks">
                <el-input
                  v-model="purchaseForm.remarks"
                  placeholder="请输入备注"
				  type="textarea"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
      <!-- 下部分：药品出库明细列表 -->
      <div class="medicine-detail-section">
        <!-- 在药品明细表格上方添加扫码枪录入区域 -->
        <div class="scan-input-section" style="margin-bottom: 15px;">
          <h3 class="section-title" style="display: inline-block; margin-right: 20px;">
            药品出库明细列表
          </h3>
          
          <!-- 新增追溯码快速录入区域 -->
          <div class="quick-trace-search" style="display: inline-block; margin-right: 20px;">
            <el-input
              v-model="quickTraceCodeInput"
              placeholder="请扫描或输入追溯码"
              size="mini"
              style="width: 240px"
              clearable
              @keyup.enter.native="handleQuickSearch"
            >
              <el-button
                slot="append"
                icon="el-icon-Ssearch"
                @click="handleQuickSearch"
                :loading="quickSearchLoading"
              ></el-button>
            </el-input>
          </div>
          
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="addMedicineRow"
            v-if="currentMode === 'add' || currentMode === 'edit'"
            :disabled="!purchaseForm.warehouseId"
            style="float: right;"
          >
            添加药品
          </el-button>
        </div>
        
        <!-- 药品明细表格 -->
        <el-table
          :data="medicineList"
          style="width: 100%"
          stripe
          border
          size="mini"
          max-height="400px"
          v-loading="tableLoading"
        >
          <!-- 行号 -->
          <el-table-column
            type="index"
            label="#"
            width="60"
            align="center"
            fixed
          />
          
          <!-- 药品名称 -->
          <el-table-column
            prop="drugName"
            label="药品名称"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.drugName || '--' }}
              </template>
              <template v-else>
                <!-- 药品名称下拉框 -->
                <el-select
                  v-model="scope.row.dugInvyId"
                  :popper-class="'xyk-outbound-drug-select-popper'"
                  placeholder="请选择药品"
                  clearable
                  filterable
                  style="width: 100%"
                  :disabled="(currentMode === 'edit' && scope.row.isLocked && !scope.row.isEditing) || currentMode === 'view' || currentMode === 'submit' || currentMode === 'review' || currentMode === 'pass'"
                  @change="(value) => handleDrugChange(value, scope.row, scope.$index)"
                  size="mini"
                >
                  <el-option
                    v-for="item in drugOptions"
                    :key="`${item.invyId || item.dugInvyId}`"
                    :label="item.drugName"
                    :value="item.invyId || item.dugInvyId"
                  >
                    <div style="display: flex;flex-direction: column;line-height: 1.4; padding: 8px 0;">
                      <div style="display: flex; justify-content: space-between; align-items: center;">
                        <span>{{ item.drugName }}</span>
                        <span style="font-size: 12px;">批次号：{{ item.manuLotnum || '无批次' }}</span>
                      </div>
                      <div style="font-size: 12px; margin-top: 4px;">
                        规格：{{ item.drugSpec }}
                      </div>
                    </div>
                  </el-option>
                  
                  <!-- 加载更多选项 -->
                  <el-option
                    v-if="drugOptions.length > 0 && drugOptions.length < totalDrugs"
                    key="load-more"
                    disabled
                    style="text-align: center;"
                  >
                    <el-button
                      type="text"
                      size="mini"
                      :loading="drugLoading"
                      @click="loadMoreDrugs"
                      style="width: 100%;"
                    >
                      加载更多...
                    </el-button>
                  </el-option>
                  
                  <!-- 无数据提示 -->
                  <el-option
                    v-if="!drugLoading && drugOptions.length === 0"
                    key="no-data"
                    disabled
                    style="text-align: center; color: #909399;"
                  >
                    暂无数据
                  </el-option>
                </el-select>
              </template>
            </template>
          </el-table-column>
          
          <!-- 出库数量 -->
          <el-table-column
            label="出库数量"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.outQuantity || '--' }}{{ scope.row.unit ? ' ' + scope.row.unit : '' }}
              </template>
              <template v-else>
                <div class="out-quantity-container" style="display: flex; align-items: center; gap: 8px;">
                  <!-- 出库数量输入框 -->
                  <el-input
                    v-model="scope.row.outQuantity"
                    placeholder="请输入数量"
                    style="width: 120px"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit' || (scope.row.isLocked && !scope.row.isEditing) || !scope.row.drugId"
                    @input="(value) => handleQuantityChange(value, scope.row, scope.$index)"
                    size="mini"
                  />
                  <!-- 单位文字独立显示 -->
                  <span style="color: #606266; font-size: 12px; min-width: 30px;">
                    {{ scope.row.unit || '--' }}
                  </span>
                </div>
              </template>
            </template>
          </el-table-column>
          
          <!-- 库存类型 -->
          <el-table-column
            label="库存类型"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.stockType === 1 ? '最小单位' : '包装单位' }}
              </template>
              <template v-else>
                <!-- 库存类型下拉框 -->
                <el-select
                  v-model="scope.row.stockType"
                  placeholder="库存类型"
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit' || (scope.row.isLocked && !scope.row.isEditing)"
                  @change="(value) => handleStockTypeChange(value, scope.row)"
                  size="mini"
                >
                  <el-option label="最小单位" :value="1" />
                  <el-option label="包装单位" :value="2" />
                </el-select>
              </template>
            </template>
          </el-table-column>
          
          <!-- 包装数量 -->
          <el-table-column
            prop="pacCnt"
            label="包装数量"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.pacCnt || '--' }}
            </template>
          </el-table-column>
          <!-- 实际库存数量 -->
          <el-table-column
            prop="purcCnt"
            label="实际库存数量"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.purcCnt || '--' }}
            </template>
          </el-table-column>
          
          <!-- 当前出库成本 -->
          <el-table-column label="当前出库成本" width="180" align="center">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                <el-input
                  v-model="scope.row.currentOutCost"
                  size="mini"
                  style="width: 120px;"
                  :disabled="isViewMode || isSubmitMode || isReviewMode || isPassMode || isRollbackMode || !scope.row.drugId"
                  @change="(value) => handleCurrentOutCostChange(value, scope.row, scope.$index)"
                  @blur="(event) => handleCurrentOutCostBlur(event, scope.row, scope.$index)"
                  :formatter="value => formatDecimal(value, 8)"
                  :parser="value => parseFloat(value) || 0"
                  placeholder="请输入成本"
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
            </template>
          </el-table-column>
          
          <!-- 当前出库零售 -->
          <el-table-column
            prop="currentOutSale"
            label="当前出库零售"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.currentOutSale !== undefined && scope.row.currentOutSale !== null">
                ¥{{ formatAmount(scope.row.currentOutSale) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- 生产厂家 -->
          <el-table-column
            prop="prodentpName"
            label="生产厂家"
            width="150"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.prodentpName || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产批号 -->
          <el-table-column
            prop="manuLotnum"
            label="生产批号"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.manuLotnum || '--' }}
            </template>
          </el-table-column>
          
          <!-- 入库成本 -->
          <el-table-column
            prop="purcPric"
            label="入库成本"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.purcPric !== undefined && scope.row.purcPric !== null">
                ¥{{ formatAmount(scope.row.purcPric) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- 入库零售 -->
          <el-table-column
            prop="salePric"
            label="入库零售"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.salePric !== undefined && scope.row.salePric !== null">
                ¥{{ formatAmount(scope.row.salePric) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
		  <!-- 加成方式 -->
		  <el-table-column prop="markUpMethodText" label="加成方式" width="100" align="center">
		    <template slot-scope="scope">
		      {{ scope.row.markUpMethodText || '--' }}
		    </template>
		  </el-table-column>
		  
		  <!-- 加成比例 -->
		  <el-table-column prop="markUpRatio" label="加成比例" width="100" align="center">
		    <template slot-scope="scope">
		      {{ scope.row.markUpRatio ? (scope.row.markUpRatio * 100).toFixed(2) + '%' : '--' }}
		    </template>
		  </el-table-column>
		  
		  <!-- 加成金额 -->
		  <el-table-column prop="markUpAmount" label="加成金额" width="100" align="center">
		    <template slot-scope="scope">
		      {{ scope.row.markUpAmount ? '¥' + formatAmount(scope.row.markUpAmount) : '--' }}
		    </template>
		  </el-table-column>
		  
		  <!-- 是否指定售价 -->
		  <el-table-column prop="isFixedPriceText" label="指定售价" width="100" align="center">
		    <template slot-scope="scope">
		      {{ scope.row.isFixedPriceText || '--' }}
		    </template>
		  </el-table-column>
		  
          <!-- 规格 -->
          <el-table-column
            prop="drugSpec"
            label="规格"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.drugSpec || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产日期 -->
          <el-table-column
            prop="manuDate"
            label="生产日期"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.manuDate) || '--' }}
            </template>
          </el-table-column>
		  
		  <!-- 库存ID -->
		  <el-table-column
		    prop="dugInvyId"
		    label="库存ID"
		    width="100"
		    align="center"
		    v-if="currentMode === 'view'"
		  >
		    <template slot-scope="scope">
		      {{ scope.row.dugInvyId || '--' }}
		    </template>
		  </el-table-column>
		  
          <!-- 有效期 -->
          <el-table-column
            prop="expyDate"
            label="有效期"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.expyDate) || '--' }}
            </template>
          </el-table-column>
          
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="200"
            align="center"
            fixed="right"
            v-if="currentMode === 'add' || currentMode === 'edit'"
          >
            <template slot-scope="scope">
              <!-- 锁定状态：修改、追溯码、移除 -->
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                <!-- 修改按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  @click="handleEditRow(scope.row, scope.$index)"
                  v-if="currentMode === 'edit'"
                >
                  修改
                </el-button>
                
                <!-- 追溯码按钮（根据isBar字段显示） -->
                <el-button
                  v-if="scope.row.isBar === 1"
                  type="text"
                  size="mini"
                  style="color: #409EFF;"
                  @click="handleTraceCode(scope.row, scope.$index)"
                  :disabled="!scope.row.drugId"
                >
                  追溯码
                  <span v-if="scope.row.traceCodes && scope.row.traceCodes.length > 0">
                    ({{ scope.row.traceCodes.length }})
                  </span>
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
              
              <!-- 编辑状态：取消、追溯码、移除 -->
              <template v-else-if="scope.row.isEditing">
                <!-- 取消按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  class="cancel-btn"
                  @click="handleCancelEdit(scope.row, scope.$index)"
                >
                  取消
                </el-button>
                
                <!-- 追溯码按钮（编辑状态下也显示，但可能需要禁用） -->
                <el-button
                  v-if="scope.row.isBar === 1"
                  type="text"
                  size="mini"
                  style="color: #409EFF;"
                  @click="handleTraceCode(scope.row, scope.$index)"
                  :disabled="true"
                  title="请先完成编辑"
                >
                  追溯码
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
              
              <!-- 新增状态：追溯码、移除 -->
              <template v-else>
                <!-- 追溯码按钮（新增状态下显示） -->
                <el-button
                  v-if="scope.row.isBar === 1 && scope.row.drugId"
                  type="text"
                  size="mini"
                  style="color: #409EFF;"
                  @click="handleTraceCode(scope.row, scope.$index)"
                  :disabled="!scope.row.drugId"
                >
                  追溯码
                  <span v-if="scope.row.traceCodes && scope.row.traceCodes.length > 0">
                    ({{ scope.row.traceCodes.length }})
                  </span>
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 合计行 -->
        <div class="summary-row" v-if="medicineList.length > 0">
          <div class="summary-item">
            <span class="summary-label">总出库数量：</span>
            <span class="summary-value">{{ totalOutQuantity }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">总出库成本：</span>
            <span class="summary-value">¥{{ formatAmount(totalOutCost) }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">总出库零售：</span>
            <span class="summary-value">¥{{ formatAmount(totalOutSale) }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 模态框底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <!-- 查看模式 -->
      <template v-if="currentMode === 'view'">
        <el-button @click="handlePrint" size="mini" :disabled="true">打印</el-button>
        <el-button @click="handleScreenshot" size="mini" type="primary" :disabled="true">截图保存</el-button>
        <el-button @click="handleClose" size="mini">关闭</el-button>
      </template>
      
      <!-- 新增模式 -->
      <template v-else-if="currentMode === 'add'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSaveDraft" 
          size="mini" 
          type="info"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          存为草稿
        </el-button>
        <el-button 
          @click="handleSaveSubmit" 
          size="mini" 
          type="primary"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存提交
        </el-button>
      </template>
      
      <!-- 修改模式 -->
      <template v-else-if="currentMode === 'edit'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSaveDraft" 
          size="mini" 
          type="info"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存草稿
        </el-button>
        <el-button 
          @click="handleSaveSubmit" 
          size="mini" 
          type="primary"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存提交
        </el-button>
      </template>
      
      <!-- 提交模式 -->
      <template v-else-if="currentMode === 'submit'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSubmitReview" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          提交审核
        </el-button>
      </template>
      
      <!-- 审核模式 -->
      <template v-else-if="currentMode === 'review'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button @click="handleRollbackDraft" size="mini" type="warning">回退草稿</el-button>
        <el-button 
          @click="handleReviewPass" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          确认审核
        </el-button>
      </template>
      
      <!-- 过单模式 -->
      <template v-else-if="currentMode === 'pass'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button @click="handleRollbackSubmit" size="mini" type="warning">回退提交</el-button>
        <el-button 
          @click="handlePassOutbound" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          过单出库
        </el-button>
      </template>
	  
	  <!-- 追溯码补录模态框 -->
	  <el-dialog 
	    title="追溯码补录"
	    :visible.sync="traceCodeSupplementDialogVisible" 
	    width="90%"
	    :close-on-click-modal="false"
	    top="2vh"
	    custom-class="trace-code-supplement-dialog"
	    class="trace-code-modal"
	  >
	    <!-- 模态框头部区域 -->
	    <div class="dialog-header" slot="title" style="text-align: left;">
	      <span class="dialog-title-text">{{ traceCodeDialogTitle }}</span>
	    </div>
	    
	    <!-- 模态框内容区域 -->
	    <div class="trace-code-supplement-dialog-content">
	      <!-- 添加新的追溯码按钮 -->
	      <div class="add-button-section" style="margin-bottom: 15px;">
	        <el-button
	          type="primary"
	          icon="el-icon-plus"
	          size="small"
	          @click="handleAddSupplementTraceCode"
	        >
	          添加追溯码
	        </el-button>
	      </div>
	      
	      <!-- 统计信息区域 -->
	      <div class="summary-info-section" v-if="currentTraceMedicine" style="margin-bottom: 15px; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
	        <el-row :gutter="20">
	          <el-col :span="6">
	            <div class="summary-item">
	              <span class="label">药品名称：</span>
	              <span class="value">{{ currentTraceMedicine.drugName || '--' }}</span>
	            </div>
	          </el-col>
	          <el-col :span="6">
	            <div class="summary-item">
	              <span class="label">出库数量：</span>
	              <span class="value">{{ currentTraceMedicine.outQuantity || 0 }}</span>
	            </div>
	          </el-col>
	          <el-col :span="6">
	            <div class="summary-item">
	              <span class="label">已录入数量：</span>
	              <span class="value" :class="{ 'warning': traceCodeSupplementList.filter(tc => tc.traceCode).length !== currentTraceMedicine.outQuantity }">
	                {{ traceCodeSupplementList.filter(tc => tc.traceCode).length }}
	              </span>
	            </div>
	          </el-col>
	        </el-row>
	      </div>
	      
	      <!-- 追溯码表格区域 -->
	      <div class="trace-code-table-section">
	        <el-table
	          :data="traceCodeSupplementList"
	          style="width: 100%"
	          border
	          size="mini"
	          height="300"
	          class="trace-code-table"
	          :row-class-name="getTraceCodeRowClassName"
	        >
	          <el-table-column
	            prop="traceCode"
	            label="追溯码"
	            min-width="200"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <el-input
	                v-model="scope.row.traceCode"
	                placeholder="请输入追溯码"
	                size="mini"
	                clearable
	                @blur="handleTraceCodeBlur(scope.row, scope.$index)"
	                :disabled="scope.row.isVerifying"
	              >
	                <i slot="suffix" v-if="scope.row.isVerifying" class="el-icon-loading"></i>
	              </el-input>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="drugName"
	            label="药品名称"
	            min-width="150"
	            align="center"
	            show-overflow-tooltip
	          >
	            <template slot-scope="scope">
	              <span>{{ scope.row.drugName || '--' }}</span>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="spec"
	            label="规格"
	            width="120"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <span>{{ scope.row.spec || '--' }}</span>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="availableQty"
	            label="可用数量"
	            width="100"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <el-input-number
	                v-model="scope.row.availableQty"
	                :min="1"
	                :step="1"
	                size="mini"
	                style="width: 100%"
	                :disabled="true"
	                :controls="false"
	              ></el-input-number>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="manufacturer"
	            label="生产厂家"
	            width="150"
	            align="center"
	            show-overflow-tooltip
	          >
	            <template slot-scope="scope">
	              <span>{{ scope.row.manufacturer || '--' }}</span>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="batchNo"
	            label="生产批号"
	            width="150"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <span>{{ scope.row.batchNo || '--' }}</span>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="produceDate"
	            label="生产日期"
	            width="120"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <span>{{ scope.row.produceDate || '--' }}</span>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="expireDate"
	            label="有效期"
	            width="120"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <span>{{ scope.row.expireDate || '--' }}</span>
	            </template>
	          </el-table-column>
	          
	          <el-table-column
	            prop="remark"
	            label="备注"
	            min-width="150"
	            align="center"
	          >
	            <template slot-scope="scope">
	              <el-input
	                v-model="scope.row.remark"
	                placeholder="请输入备注"
	                size="mini"
	                clearable
	              ></el-input>
	            </template>
	          </el-table-column>
	          
	          <!-- 验证状态列 -->
	          <el-table-column
	            label="验证状态"
	            width="120"
	            align="center"
	            fixed="right"
	          >
	            <template slot-scope="scope">
	              <div v-if="scope.row.isVerifying" class="validating-status">
	                <i class="el-icon-loading"></i>
	                <span style="margin-left: 5px; font-size: 12px;">验证中...</span>
	              </div>
	              <div v-else-if="scope.row.validationStatus === 'success'" class="success-status">
	                <i class="el-icon-success" style="color: #67C23A;"></i>
	                <span style="margin-left: 5px; font-size: 12px; color: #67C23A;">验证通过</span>
	              </div>
	              <div v-else-if="scope.row.validationStatus === 'error'" class="error-status">
	                <i class="el-icon-error" style="color: #F56C6C;"></i>
	                <span style="margin-left: 5px; font-size: 12px; color: #F56C6C;">验证失败</span>
	              </div>
	              <div v-else class="pending-status">
	                <i class="el-icon-question" style="color: #909399;"></i>
	                <span style="margin-left: 5px; font-size: 12px; color: #909399;">待验证</span>
	              </div>
	            </template>
	          </el-table-column>
	          
	          <!-- 操作列 - 固定在右侧 -->
	          <el-table-column
	            label="操作"
	            width="80"
	            align="center"
	            fixed="right"
	          >
	            <template slot-scope="scope">
	              <el-button
	                type="text"
	                size="mini"
	                style="color: #F56C6C;"
	                @click="handleDeleteTraceCodeRow(scope.$index)"
	              >
	                删除
	              </el-button>
	            </template>
	          </el-table-column>
	        </el-table>
	      </div>
	      
	      <!-- 新增：追溯码验证结果显示区域 -->
	      <div v-if="traceCodeValidationVisible && traceCodeValidationResult" class="validation-result-section" style="margin-top: 20px;">
	        <el-alert
	          :title="getValidationTitle()"
	          :type="getValidationType()"
	          :closable="true"
	          :show-icon="true"
	          @close="traceCodeValidationVisible = false"
	        >
	          <div class="validation-details" v-if="traceCodeValidationResult">
	            <div class="validation-details-title">追溯码详情信息：</div>
	            
	            <el-row :gutter="20" class="validation-fields">
	              <el-col :span="6">
	                <div class="validation-field">
	                  <span class="field-label">药品名称：</span>
	                  <span class="field-value">{{ traceCodeValidationResult.drugName || '--' }}</span>
	                </div>
	              </el-col>
	              
	              <el-col :span="6">
	                <div class="validation-field">
	                  <span class="field-label">包装规格：</span>
	                  <span class="field-value">{{ traceCodeValidationResult.prepnSpec || '--' }}</span>
	                </div>
	              </el-col>
	              
	              <el-col :span="6">
	                <div class="validation-field">
	                  <span class="field-label">包装数量：</span>
	                  <span class="field-value">{{ traceCodeValidationResult.pacCnt || 1 }}</span>
	                </div>
	              </el-col>
	              
	              <el-col :span="6">
	                <div class="validation-field">
	                  <span class="field-label">批准文号：</span>
	                  <span class="field-value">{{ traceCodeValidationResult.approvalLicenceNo || '--' }}</span>
	                </div>
	              </el-col>
	              
	              <el-col :span="6">
	                <div class="validation-field">
	                  <span class="field-label">有效期：</span>
	                  <span class="field-value">{{ traceCodeValidationResult.expireDate || '--' }}</span>
	                </div>
	              </el-col>
	            </el-row>
	            
	            <!-- 验证结论 -->
	            <div v-if="currentValidatingRowIndex !== -1 && traceCodeSupplementList[currentValidatingRowIndex]" class="validation-conclusion">
	              <div class="conclusion-title">验证结论：</div>
	              <div :class="['conclusion-content', getConclusionClass()]">
	                <i :class="getConclusionIcon()" style="margin-right: 8px;"></i>
	                {{ getValidationConclusion() }}
	              </div>
	            </div>
	          </div>
	        </el-alert>
	      </div>
	    </div>
	    
	    <!-- 模态框底部按钮 -->
	    <div slot="footer" class="trace-code-dialog-footer">
	      <el-button
	        size="small"
	        @click="traceCodeSupplementDialogVisible = false"
	      >
	        取消
	      </el-button>
	      <el-button
	        type="primary"
	        size="small"
	        @click="handleConfirmTraceCodeSupplement"
	        :disabled="!enableConfirmButton"
	      >
	        确定
	      </el-button>
	    </div>
	  </el-dialog>
	  
	  <!-- 过单出库进度模态框 -->
	  <el-dialog
	    title="追溯码上传进度"
	    :visible.sync="passProgressDialogVisible"
	    width="60%"
		top="2vh"
	    :close-on-click-modal="false"
	    :show-close="false"
	    class="progress-dialog"
	    center
	  >
	    <div class="progress-dialog-content">
	      <!-- 步骤列表 -->
	      <div class="step-list">
	        <div 
	          v-for="(step, index) in passProgressSteps" 
	          :key="index" 
	          class="step-item"
	          :class="{
	            'step-active': index === passCurrentStep,
	            'step-completed': step.status === 'finish',
	            'step-error': step.status === 'error'
	          }"
	        >
	          <!-- 步骤图标 -->
	          <div class="step-icon">
	            <i v-if="step.icon" :class="step.icon" :style="{ color: step.status === 'error' ? '#F56C6C' : '#67C23A' }"></i>
	            <div v-else class="step-number">{{ index + 1 }}</div>
	          </div>
	          
	          <!-- 步骤内容 -->
	          <div class="step-content">
	            <div class="step-header">
	              <div class="step-title">{{ step.title }}</div>
	              
	              <!-- 重新补传按钮（只在第四步失败时显示） -->
	              <div v-if="step.showRetryButton && index === 3" class="step-retry-button">
	                <el-button
	                  type="warning"
	                  size="mini"
	                  :loading="step.retryLoading"
	                  @click="handleRetryUpload"
	                  icon="el-icon-refresh"
	                >
	                  重新补传
	                </el-button>
	              </div>
	            </div>
	            
	            <!-- 步骤描述 -->
	            <div v-if="step.description" class="step-description">
	              {{ step.description }}
	            </div>
	            
	            <!-- 显示需要上传的药品列表 -->
	            <div v-if="index === 1 && needUploadDrugs.length > 0" class="step-description">
	              需要上传追溯码的药品：
	              <ul>
	                <li v-for="drug in needUploadDrugs" :key="drug.drugName">
	                  {{ drug.drugName }}
	                </li>
	              </ul>
	            </div>
	            
	            <!-- 显示追溯码提取结果 -->
	            <div v-if="index === 3 && traceCodeCount > 0" class="step-description">
	              共提取到 {{ traceCodeCount }} 个追溯码
	            </div>
	            
	            <!-- 进度条（用于上传步骤） -->
	            <div v-if="step.showProgressBar && (step.status === 'process' || step.status === 'finish')" class="step-progress">
	              <el-progress
	                :percentage="step.progress"
	                :stroke-width="8"
	                :show-text="false"
	                :color="step.status === 'error' ? '#F56C6C' : '#409EFF'"
	              ></el-progress>
	              <div class="progress-text">{{ step.progress.toFixed(0) }}%</div>
	            </div>
	            
	            <!-- 完成状态 -->
	            <div v-if="step.status === 'finish' && step.progress >= 100" class="step-complete">
	              <i class="el-icon-success" style="color: #67C23A; margin-right: 5px;"></i>
	              已完成
	            </div>
	            
	            <!-- 错误状态 -->
	            <div v-if="step.status === 'error'" class="step-error">
	              <i class="el-icon-error" style="color: #F56C6C; margin-right: 5px;"></i>
	              失败
	            </div>
	          </div>
	        </div>
	      </div>
	      
	      <!-- 总进度条 -->
	      <div class="total-progress-section">
	        <div class="total-progress-title">总进度</div>
	        <el-progress
	          :percentage="totalProgress"
	          :stroke-width="12"
	          :color="totalProgress < 100 ? '#409EFF' : '#67C23A'"
	          :show-text="true"
	          :format="formatTotalProgress"
	        ></el-progress>
	      </div>
	    </div>
	    
	    <!-- 底部按钮区域 -->
	    <div slot="footer" class="progress-dialog-footer">
	      <!-- 关闭按钮（在上传失败时显示） -->
	      <el-button
	        v-if="showCloseButton"
	        size="small"
	        @click="handleCloseProgressDialog"
	      >
	        关闭
	      </el-button>
	    </div>
	  </el-dialog>
	  
	  <!-- 新增：追溯码快捷录入确认模态框 -->
	  <el-dialog
	    title="追溯码药品信息确认"
	    :visible.sync="traceCodeQuickDialogVisible"
	    width="600px"
	    :close-on-click-modal="false"
	    custom-class="quick-trace-dialog"
	    append-to-body
	  >
	    <div class="quick-trace-content" v-if="quickDrugInfo">
	      <el-form label-width="100px" size="small">
	        <el-form-item label="追溯码：">
	          <span>{{ quickTraceCodeDisplay }}</span>
	        </el-form-item>
	        <el-form-item label="药品名称：">
	          <span>{{ quickDrugInfo.drugName || '--' }}</span>
	        </el-form-item>
	        <el-form-item label="规格：">
	          <span>{{ quickDrugInfo.prepnSpec || '--' }}</span>
	        </el-form-item>
	        <el-form-item label="包装数量：">
	          <span>{{ quickDrugInfo.pacCnt || 1 }}</span>
	        </el-form-item>
	        <el-form-item label="生产厂家：">
	          <span>{{ quickDrugInfo.manufacturer || '--' }}</span>
	        </el-form-item>
	        <el-form-item label="生产批号：">
	          <span>{{ quickDrugInfo.batchNo || '--' }}</span>
	        </el-form-item>
	        <el-form-item label="有效期：">
	          <span>{{ quickDrugInfo.expireDate || '--' }}</span>
	        </el-form-item>
	      </el-form>
	    </div>
	    <div slot="footer" class="dialog-footer">
	      <el-button @click="traceCodeQuickDialogVisible = false">取消</el-button>
	      <el-button type="primary" @click="confirmQuickAddDrug" :loading="quickAddLoading">确定添加</el-button>
	    </div>
	  </el-dialog>
	  
    </div>
  </el-dialog>
</template>
 
<script>
import { 
	  msfxCodeDetail, 
	  msfxGetEntInfoList, 
	  msfListUpoutDetail, 
	  msfxUploadInoutBill, 
	  msfxUploadRetail,
	  getSomeWare,  // 新增：根据药品名称和包装数量检索接口
	  getCJSomeWare  // 新增：根据批准文号和药品ID获取厂家信息接口
	} from "@/api/systemCatalogue/Western.js";
	
	// 系统参数列表
	import { getSystemList } from "@/api/systemParameter/systemParameter"
	
import { addSupplierEntity,docMarkById } from "@/api/PSI.js";
import { findAttribute } from "@/api/user.js"
import {
  selectDropDownList,
  selectYFtoYKDrug,
  addXYFOutbound,
  toXYFRetnExamine,
  editXYFdocOut,
  selectOut,
  docXYFOutJoin
} from "@/api/PSI/shopReturn.js";
 
export default {
  name: 'AddXyfModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      default: 'add' // add, edit, view, submit, review, pass
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    putinTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentMode: 'add',
      purchaseForm: {
        warehouseId: 3, // 出库药库，默认1西药库
        businessDate: this.getCurrentDate(), // 业务日期
        invoiceNo: '', // 发票号码
        supplierId: '', // 供货单位ID
        supplierNo: '', // 供应商号码
		deptId: '', // 科室
        outTypeId: 11, // 出库方式ID，默认11采购退库
        remarks: '' // 备注
      },
	  searchQuery: '', // 搜索关键词
	  loadingMore: false, // 是否正在加载更多
	  showLoadMore: false, // 是否显示加载更多按钮
	  isSearching: false, // 是否正在搜索
      purchaseRules: {
        warehouseId: [
          { required: true, message: '请选择出库药库', trigger: 'change' }
        ],
        businessDate: [
          { required: true, message: '请选择业务日期', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        outTypeId: [
          { required: true, message: '请选择出库方式', trigger: 'change' }
        ]
      },
      warehouseOptions: [
        { id: 3, name: '西药房' },
      ],
	  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      supplierOptions: [], // 供货单位选项
	  deptOptions: [], // 出库科室选项
      outTypeOptions: [], // 出库方式选项
      medicineList: [], // 药品明细列表
      drugOptions: [], // 药品选项
      tableLoading: false,
      submitLoading: false,
      drugLoading: false,
      
	  // 追溯码相关数据
	  traceCodeDialogVisible: false, // 追溯码录入模态框显示
	  currentTraceMedicine: null, // 当前操作追溯码的药品行
	  traceCodeList: [], // 追溯码列表
	  scanInput: '', // 扫码输入框
	  traceCodeLoading: false, // 追溯码加载状态
	  // 追溯码补录相关
	  traceCodeSupplementDialogVisible: false, // 追溯码补录模态框显示
	  // 扫码枪录入相关
	  scanTraceCode: '', // 扫码枪输入框
	  scanLoading: false, // 扫码搜索加载状态
	  // 新增：确认按钮状态控制
	  enableConfirmButton: false, // 控制追溯码模态框确认按钮的启用状态
	  // 追溯码录入模态框
	  // 追溯码验证相关
	  traceCodeValidationResult: null, // 追溯码验证结果
	  traceCodeValidationLoading: false, // 验证加载状态
	  traceCodeValidationVisible: false, // 验证结果显示区域
	  currentValidatingRowIndex: -1, // 当前正在验证的行索引
	  
	  // 追溯码补录列表中的验证状态
	  traceCodeSupplementList: [], // 追溯码补录列表
	  
	  // 用于getSomeWare接口的数据
	  getSomeWareData: null, // getSomeWare接口返回的数据
	  
	  // 新增的追溯码行
	  newTraceCodeRow: {
		traceCode: '',
		drugName: '',
		spec: '',
		availableQty: 1,
		manufacturer: '',
		batchNo: '',
		produceDate: '',
		expireDate: '',
		remark: '',
		validationStatus: 'pending' // pending, success, error
	  },
	  traceCodeInputForm: {
		traceCode: '', // 追溯码
		drugName: '', // 药品名称
		spec: '', // 规格
		pacCnt: 1, // 包装数量
		inboundQty: 1, // 入库数量
		purcType: 2, // 库存类型
		manuLotnum: '', // 生产批号
		manufacturer: '', // 生产厂家
		approvalLicenceNo: '', // 批准文号
		produceDate: '', // 生产日期
		expireDate: '', // 有效期
		remark: '' // 备注
	  },
		
	  // 追溯码模态框标题
	  traceCodeDialogTitle: '出库追溯码录入',
	  // 步骤进度相关
	  passProgressDialogVisible: false,
	  passProgressSteps: [
		{ 
		  title: '正在确认过单单据', 
		  status: 'wait',
		  description: '',
		  icon: 'el-icon-document',
		  showProgressBar: false,
		  progress: 0
		},
		{ 
		  title: '正在检查是否需要上传追溯码', 
		  status: 'wait',
		  description: '',
		  icon: 'el-icon-search',
		  showProgressBar: false,
		  progress: 0
		},
		{ 
		  title: '正在接入码上放心平台', 
		  status: 'wait',
		  description: '',
		  icon: 'el-icon-connection',
		  showProgressBar: false,
		  progress: 0
		},
		{ 
		  title: '上传追溯码至码上放心平台', 
		  status: 'wait',
		  description: '',
		  icon: 'el-icon-upload',
		  showProgressBar: true,
		  progress: 0,
		  showRetryButton: false,
		  retryLoading: false
		},
		{ 
		  title: '已完成过单出库', 
		  status: 'wait',
		  description: '',
		  icon: 'el-icon-check',
		  showProgressBar: false,
		  progress: 0
		},
		{ 
		  title: '已完成', 
		  status: 'wait',
		  description: '',
		  icon: 'el-icon-success',
		  showProgressBar: false,
		  progress: 0
		}
	  ],
	  passCurrentStep: 0,
	  needUploadTraceCode: false,
	  needUploadDrugs: [], // 需要上传追溯码的药品列表
	  traceCodeString: '',
	  traceCodeCount: 0,
	  msfxEntId: '',
	  showCloseButton: false,
	  totalProgress: 0, // 总进度
	  showRetryButton: false, // 显示重新补传按钮
	  retryLoading: false, // 重新补传加载状态
	  retryTips: '', // 重新补传提示
	  currentStepDetail: null, // 当前步骤详情
      // 分页参数
      pageNum: 1,
      pageSize: 50,
      totalDrugs: 0,
      drugName: '', // 药品搜索名称
      
      // 当前编辑的行索引
      editingRowIndex: -1,
      
      // 新增：追溯码快捷录入相关
      quickTraceCodeInput: '',      // 输入框绑定的追溯码
      quickSearchLoading: false,    // 查询按钮加载状态
      traceCodeQuickDialogVisible: false,  // 快捷录入确认模态框
      quickTraceCodeDisplay: '',    // 显示的追溯码
      quickDrugInfo: null,          // 从追溯码解析的药品信息
      quickAddLoading: false,       // 确定添加按钮加载状态
      quickMatchedDrug: null        // 匹配到的药品完整信息
    };
  },
  computed: {
	isViewMode() {
	    return this.currentMode === 'view';
	  },
	  isSubmitMode() {
	    return this.currentMode === 'submit';
	  },
	  isReviewMode() {
	    return this.currentMode === 'review';
	  },
	  isPassMode() {
	    return this.currentMode === 'pass';
	  },
	  isRollbackMode() {
	    return this.currentMode === 'rollback';
	  },
    getDialogTitle() {
        const titleMap = {
          'add': '创建西药库出库单',
          'edit': `修改 - ${this.rowData?.docNum || ''}`,
          'view': `查看出库单-${this.rowData?.docNum || ''}的详情`,
          'submit': `提交${this.rowData?.docNum || ''}的出库单`,
          'review': `审核${this.rowData?.docNum || ''}的出库单`,
          'pass': `确认过单${this.rowData?.docNum || ''}完成出库`
        };
        return titleMap[this.currentMode] || '出库单';
      },
	// 总出库数量
	totalOutQuantity() {
	  // 在详情、修改、提交、审核、过单模式下，显示接口返回的列表长度
	  if (['view', 'edit', 'submit', 'review', 'pass'].includes(this.currentMode)) {
	    return this.medicineList.length;
	  } else {
	    // 新增模式下，计算每行出库数量的累加
	    return this.medicineList.reduce((total, item) => {
	      const quantity = parseFloat(item.outQuantity) || 0;
	      return total + quantity;
	    }, 0);
	  }
	},
	// 总出库成本（使用当前出库成本累加）
	totalOutCost() {
	  return this.medicineList.reduce((total, item) => {
	    const cost = parseFloat(item.currentOutCost) || 0;
	    return total + cost;
	  }, 0);
	},
	// 总出库零售（使用当前出库零售累加）
	totalOutSale() {
	  return this.medicineList.reduce((total, item) => {
	    const sale = parseFloat(item.currentOutSale) || 0;
	    return total + sale;
	  }, 0);
	},
    // 是否可以保存（新增/修改模式下）
    canSave() {
      console.log('检查是否可以保存，当前模式:', this.currentMode);
      
      // 只有在新增和修改模式下才需要检查保存条件
      if (this.currentMode !== 'add' && this.currentMode !== 'edit') {
        return true;
      }
      
      // 检查必填字段
      if (!this.purchaseForm.warehouseId || 
          !this.purchaseForm.supplierId || 
          !this.purchaseForm.outTypeId) {
        console.log('采购信息不完整，缺少必填字段');
        return false;
      }
      
      // 检查药品明细列表是否有数据
      if (this.medicineList.length === 0) {
        console.log('药品明细列表为空');
        return false;
      }
      
      // 检查是否有行处于编辑状态
      const hasEditingRows = this.medicineList.some(item => item.isEditing);
      if (hasEditingRows) {
        console.log('有行处于编辑状态，禁用底部按钮');
        return false;
      }
      
      // 新增模式和修改模式的区别处理
      if (this.currentMode === 'add') {
        // 新增模式下，检查所有行是否都已通过库存验证
        for (let i = 0; i < this.medicineList.length; i++) {
          const item = this.medicineList[i];
          console.log(`新增模式 - 第${i + 1}行状态:`, {
            drugName: item.drugName,
            isLocked: item.isLocked,
            verified: item.verified,
            outQuantity: item.outQuantity,
            drugId: item.drugId
          });
          
          // 在新增模式下，检查行是否已验证
          if (!item.isLocked && !item.verified) {
            console.log(`第${i + 1}行未验证，禁用底部按钮`);
            return false;
          }
          
          // 检查是否有必需的药品信息
          if (!item.drugId || !item.outQuantity) {
            console.log(`第${i + 1}行缺少药品信息或出库数量`);
            return false;
          }
        }
      } else if (this.currentMode === 'edit') {
        // 修改模式下，检查所有行是否都已锁定
        for (let i = 0; i < this.medicineList.length; i++) {
          const item = this.medicineList[i];
          console.log(`修改模式 - 第${i + 1}行状态:`, {
            drugName: item.drugName,
            isLocked: item.isLocked,
            isEditing: item.isEditing
          });
          
          if (!item.isLocked) {
            console.log(`第${i + 1}行未锁定，禁用底部按钮`);
            return false;
          }
        }
      }
      
      console.log('所有条件满足，启用底部按钮');
      return true;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          console.log('模态框打开，当前模式:', this.currentMode);
          this.initData();
        }
      }
    },
    mode: {
      immediate: true,
      handler(newVal) {
        console.log('模式变化:', newVal);
        this.currentMode = newVal;
      }
    },
    rowData: {
      immediate: true,
      handler(newVal) {
        console.log('rowData变化，当前模式:', this.currentMode);
        console.log('rowData:', newVal);
        if (newVal && Object.keys(newVal).length > 0) {
          this.loadRowData(newVal);
        } else {
          this.resetPurchaseForm();
        }
      }
    },
    'purchaseForm.warehouseId': {
      handler(newVal) {
        if (newVal) {
          this.loadDrugOptions();
        } else {
          this.drugOptions = [];
        }
      }
    }
  },
  mounted() {
    this.loadSupplierOptions();
	this.fetchDeptOptions();
    this.loadOutTypeOptions();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    const popper = document.querySelector('.drug-select-popper .el-select-dropdown__wrap');
    if (popper) {
      popper.removeEventListener('scroll', this.handleSelectScroll);
    }
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 初始化数据
    async initData() {
      if (this.currentMode === 'add') {
        this.resetPurchaseForm();
        this.medicineList = [];
        // 加载药品选项
        this.loadDrugOptions();
      } else {
        console.log('非新增模式，检查medicineList:', this.medicineList);
        console.log('检查药品是否有isBar字段:');
        this.medicineList.forEach((item, index) => {
          console.log(`药品 ${index + 1}:`, {
            drugName: item.drugName,
            isBar: item.isBar,
            hasIsBar: 'isBar' in item,
            traceCodes: item.traceCodes,
            hasTraceCodes: 'traceCodes' in item
          });
        });
      }
    },
    
    // 加载供货单位选项
    async loadSupplierOptions() {
      try {
        const response = await selectDropDownList();
        if (response && response.code === 200 && response.data) {
          this.supplierOptions = response.data.content;
        } else {
          this.supplierOptions = [];
        }
      } catch (error) {
        console.error('加载供货单位列表失败:', error);
        this.$message.error('加载供货单位列表失败');
        this.supplierOptions = [];
      }
    },
    
	// 获取科室选项
	async fetchDeptOptions() {
		try {
			const clinicId = this.userInfo.clinicId
			if (clinicId) {
				const res = await findAttribute({
					clinicId
				})
				if (res && res.data) {
					this.deptOptions = res.data.map(obj => {
				  // 将 name 替换为 label，并保留其他字段
				  return { deptId: obj.id , ...obj };
			});
				console.log('获取科室选项111:', this.deptOptions)
				}
			}
		} catch (error) {
			console.error('获取科室选项失败:', error)
		}
	},
	
    // 加载出库方式选项
    async loadOutTypeOptions() {
      try {
        const response = await selectOut();
        if (response && response.code === 200 && response.data) {
          this.outTypeOptions = response.data;
        } else {
          this.outTypeOptions = [];
        }
      } catch (error) {
        console.error('加载出库方式列表失败:', error);
        this.$message.error('加载出库方式列表失败');
        this.outTypeOptions = [];
      }
    },
    
    async loadDrugOptions(isLoadMore = false) {
      if (!this.purchaseForm.warehouseId) {
        this.drugOptions = [];
        return;
      }
      try {
        this.drugLoading = true;
        let response = null;
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          drugName: this.drugName
        };
        response = await selectYFtoYKDrug(params);
        
        if (response && response.code === 200) {
          const newDrugs = response.data.content || response.data || [];
          // 标准化数据，确保每个药品有 id 字段
          const mappedDrugs = newDrugs.map(item => ({
            ...item,
            id: item.id || item.drugId,
            drugId: item.drugId,
            // 保留可能的不同字段名
            markUpId: item.markUpId || item.markupId || 1,
            isFixPrice: item.isFixPrice !== undefined ? item.isFixPrice : 0,
          }));
          if (isLoadMore) {
            this.drugOptions = [...this.drugOptions, ...mappedDrugs];
          } else {
            this.drugOptions = mappedDrugs;
          }
          this.totalDrugs = response.data.totalSize || 0;
        } else {
          this.drugOptions = [];
          this.totalDrugs = 0;
        }
      } catch (error) {
        console.error('加载药品列表失败:', error);
        this.$message.error('加载药品列表失败');
        this.drugOptions = [];
        this.totalDrugs = 0;
      } finally {
        this.drugLoading = false;
      }
    },
    
    // 添加远程搜索方法
    handleRemoteSearch(query) {
      console.log('远程搜索:', query);
      this.searchQuery = query;
      this.pageNum = 1;
      this.isSearching = true;
      this.loadDrugOptions();
    },
    
    // 添加选择框获取焦点方法
    handleSelectFocus() {
      if (this.drugOptions.length === 0 && !this.drugLoading) {
        this.pageNum = 1;
        this.searchQuery = '';
        this.isSearching = false;
        this.loadDrugOptions();
      }
    },
    
    // 添加选择框显示/隐藏变化方法
    handleSelectVisibleChange(visible) {
      if (visible && this.drugOptions.length === 0 && !this.drugLoading) {
        this.pageNum = 1;
        this.searchQuery = '';
        this.isSearching = false;
        this.loadDrugOptions();
      }
    },
    
    // 添加加载更多方法
    loadMoreDrugs() {
      if (this.loadingMore) return;
      
      this.pageNum++;
      this.loadDrugOptions(true);
    },
    
    // 修改药品搜索方法
    handleDrugSearch() {
      this.pageNum = 1;
      this.isSearching = true;
      this.loadDrugOptions();
    },
    
    // 处理选择框显示/隐藏
    handleSelectVisible(visible) {
      if (visible) {
        // 选择框显示时，绑定滚动事件
        this.$nextTick(() => {
          this.bindSelectScroll();
        });
      }
    },
    
    // 绑定选择框滚动事件
    bindSelectScroll() {
      const popper = document.querySelector('.drug-select-popper .el-select-dropdown__wrap');
      if (popper) {
        popper.addEventListener('scroll', this.handleSelectScroll);
      }
    },
    
    // 处理选择框滚动
    handleSelectScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      const threshold = 50; // 距离底部50px时触发加载
      
      // 如果滚动到底部，并且还有更多数据，则加载更多
      if (scrollHeight - scrollTop - clientHeight < threshold) {
        if (!this.drugLoading && this.drugOptions.length < this.totalDrugs) {
          this.loadMoreDrugs();
        }
      }
    },
	
    // 加载行数据
    loadRowData(rowData) {
      console.log('加载行数据:==========', rowData);
      console.log('rowData.list:', rowData.list);
      
      // 填充采购信息
      this.purchaseForm = {
        warehouseId: rowData.phayId || 3,
        businessDate: rowData.businessDate || this.getCurrentDate(),
        invoiceNo: rowData.invoiceNo || '',
        supplierId: rowData.supplyCandidateId || null,
        supplierNo: rowData.supplierNo || '',
        entId: rowData.entId || '', // 关键：保存供应商 entId
        outTypeId: rowData.retnTypeId || 11,
        remarks: rowData.remarks || ''
      };
      
      // 加载药品明细
      if (rowData.list && Array.isArray(rowData.list)) {
        console.log('rowData.list 长度:', rowData.list.length);
        console.log('rowData.list 第一个元素:', rowData.list[0]);
        
        this.medicineList = rowData.list.map(item => {
          console.log('单个药品项原始数据:', item);
          console.log('item.isBar:', item.isBar, '类型:', typeof item.isBar);
          console.log('item.traceCodes:', item.traceCodes);
          console.log('item.tracCodeJson:', item.tracCodeJson);
          
          // 在详情、修改、提交、审核、过单模式下，出库数量取retnCnt
          const outQuantity = ['view', 'edit', 'submit', 'review', 'pass'].includes(this.currentMode) 
            ? (item.retnCnt || item.apllyAmt || '')
            : (item.apllyAmt || '');
          
          // 计算当前出库成本和零售
          const currentOutCost = parseFloat(item.retnAmt) || 0;
          const currentOutSale = parseFloat(item.saleAmt) || 0;
          
          // 提取追溯码信息
          let traceCodes = [];
          let tracCodeJson = '';
          
          // 从item.traceCodes获取追溯码列表
          if (item.traceCodes && Array.isArray(item.traceCodes)) {
            console.log('从item.traceCodes获取追溯码列表:', item.traceCodes);
            traceCodes = item.traceCodes;
          } else if (item.tracecodes && Array.isArray(item.tracecodes)) {
            // 尝试小写字段名
            console.log('从item.tracecodes获取追溯码列表:', item.tracecodes);
            traceCodes = item.tracecodes;
          }
          
          // 从item.tracCodeJson获取追溯码JSON
          if (item.tracCodeJson) {
            console.log('item.tracCodeJson:', item.tracCodeJson);
            tracCodeJson = item.tracCodeJson;
            // 尝试解析JSON获取追溯码数量
            try {
              const parsedCodes = JSON.parse(item.tracCodeJson);
              console.log('解析tracCodeJson成功:', parsedCodes);
              if (Array.isArray(parsedCodes) && parsedCodes.length > 0) {
                traceCodes = parsedCodes.map(code => ({
                  traceCode: code.barcode,
                  availableQty: code.chgCnt || 1
                }));
              }
            } catch (error) {
              console.error('解析tracCodeJson失败:', error);
            }
          } else if (item.traccodejson) {
            // 尝试小写字段名
            console.log('item.traccodejson:', item.traccodejson);
            tracCodeJson = item.traccodejson;
            try {
              const parsedCodes = JSON.parse(item.traccodejson);
              if (Array.isArray(parsedCodes) && parsedCodes.length > 0) {
                traceCodes = parsedCodes.map(code => ({
                  traceCode: code.barcode,
                  availableQty: code.chgCnt || 1
                }));
              }
            } catch (error) {
              console.error('解析traccodejson失败:', error);
            }
          }
          
          // 关键：获取isBar字段，尝试多种可能的字段名
          let isBar = 0;
          
          if (item.isBar !== undefined) {
            isBar = item.isBar;
            console.log('从item.isBar获取isBar:', isBar);
          } else if (item.is_bar !== undefined) {
            isBar = item.is_bar;
            console.log('从item.is_bar获取isBar:', isBar);
          } else if (item.isbar !== undefined) {
            isBar = item.isbar;
            console.log('从item.isbar获取isBar:', isBar);
          } else {
            console.log('未找到isBar字段，使用默认值0');
          }
          
          // 将isBar转换为数字
          if (typeof isBar === 'string') {
            isBar = isBar === '1' || isBar === 'true' ? 1 : 0;
          } else if (typeof isBar === 'boolean') {
            isBar = isBar ? 1 : 0;
          }
          
          console.log(`药品 ${item.drugName} 的最终isBar值:`, isBar);
          
          const medicineItem = {
            id: item.id || null,
            drugId: item.drugId || null,
            drugName: item.drugName || '',
            purcCnt: item.purcCnt || '',
            outQuantity: outQuantity,
            stockType: item.purcType || 2,
			markUpId: item.markUpId || 1,           // 加成方式
			isFixPrice: item.isFixPrice || 0,       // 是否指定售价
			markUpMethodText: '',                   // 加成方式文字
			markUpRatio: 0,                         // 加成比例
			markUpAmount: 0,                        // 加成金额
			isFixedPriceText: '',                   // 是否指定售价文字
            pacCnt: item.pacCnt || '',
            prodentpName: item.prodentpName || '',
            manuLotnum: item.manuLotnum || '',
            manuDate: item.manuDate || '',
            expyDate: item.expyDate || '',
            purcPric: item.retnPric || '',
            currentOutCost: currentOutCost,
            salePric: item.salePric || '',
            currentOutSale: currentOutSale,
            drugSpec: item.drugSpec || '',
            unit: item.unt || '',
            dosUnt: item.dosUnt || '',
            pacUnt: item.pacUnt || '',
            invId: item.dugInvyId || null,
            prodentpNameId: item.prodentpNameId || null,
            isBar: isBar, // 关键：确保isBar字段被正确赋值
            traceCodes: traceCodes, // 追溯码列表
            tracCodeJson: tracCodeJson, // 追溯码JSON字符串
            isLocked: true,
            isEditing: false,
            hasChanged: false,
            originalData: JSON.parse(JSON.stringify(item))
          };
          
          console.log('创建后的药品对象:', medicineItem);
          return medicineItem;
        });
        
        console.log('加载后的medicineList:', this.medicineList);
      } else {
        console.log('rowData.list为空或不是数组');
        this.medicineList = [];
      }
      
      // 如果有关联药库，加载对应药品选项
      if (rowData.phayId) {
        this.loadDrugOptions();
      }
    },
    
    // 重置采购表单
    resetPurchaseForm() {
      this.purchaseForm = {
        warehouseId: 3, // 默认西药房
        businessDate: this.getCurrentDate(),
        invoiceNo: '',
        supplierId: null,
		entId: this.rowData.entId || '', // 新增
        supplierNo: '',
        outTypeId: 11, // 默认采购退库
        remarks: ''
      };
      this.medicineList = [];
      this.pageNum = 1;
      this.drugName = '';
    },
    
    // 添加药品行
    addMedicineRow() {
      const newRow = {
        id: null,
        drugId: null,
        drugName: '',
        purcCnt: '',
        outQuantity: '',
        stockType: 2, // 默认包装单位
        pacCnt: '',
        prodentpName: '',
        manuLotnum: '',
        manuDate: '',
		markUpId: 4,              // 默认bu 加成
		isFixPrice: 0,            // 默认未指定售价
		markUpMethodText: '比例加成',
		markUpRatio: 0,
		markUpAmount: 0,
		isFixedPriceText: '未指定',
        expyDate: '',
        purcPric: '', // 入库成本
        currentOutCost: '', // 当前出库成本
        salePric: '', // 入库零售
        currentOutSale: '', // 当前出库零售
        drugSpec: '',
        unit: '', // 单位文字
        dosUnt: '', // 最小单位
        pacUnt: '', // 包装单位
        dugInvyId: null, // 库存ID
		invyId: null, // 库存ID
        prodentpNameId: null, // 生产厂家ID
        isBar: 0, // 是否启用追溯码，默认0
        traceCodes: [], // 追溯码列表
        tracCodeJson: '', // 新增：追溯码JSON字符串
        // 关键修改：根据模式设置初始状态
        isLocked: false, // 任何模式下新增行都未锁定
        // 关键修改：在"修改模式"下，新增行应处于编辑状态，以便触发自动验证
        isEditing: this.currentMode === 'edit', 
        hasChanged: false, // 无变化
        checkingStock: false, // 是否正在验证库存
        verified: this.currentMode === 'add', // 仅在新增模式下初始为已验证？不，应为false
        verificationResult: null, // 验证结果
        originalData: null // 无原始数据
      };
      
      // 确保 verified 初始状态正确
      if (this.currentMode === 'add') {
        newRow.verified = false; // 新增模式下，新行也未验证
      }
      
      this.medicineList.push(newRow);
      console.log(`新增药品行（模式：${this.currentMode}），isEditing: ${newRow.isEditing}，当前行数:`, this.medicineList.length);
    },
	
	// 保存已验证的行
	handleSaveVerifiedRow(row, index) {
	  if (!row.verified) {
	    this.$message.warning('该行尚未通过库存验证');
	    return;
	  }
	  
	  // 锁定已验证的行
	  row.isLocked = true;
	  row.isEditing = false;
	  row.verified = false;
	  row.originalData = JSON.parse(JSON.stringify(row));
	  
	  this.$message.success('已保存药品信息');
	},
	
    // 处理药库变更
    handleWarehouseChange(value) {
      this.medicineList.forEach(item => {
        if (!item.isLocked) {
          // 重置非锁定的药品行
          this.resetMedicineRow(item);
        }
      });
      this.loadDrugOptions();
    },
    
    // 处理供货单位变更
    handleSupplierChange(value) {
      const selectedSupplier = this.supplierOptions.find(item => item.id === value);
      if (selectedSupplier) {
        this.purchaseForm.supplierNo = selectedSupplier.supplierNo || '';
        this.purchaseForm.entId = selectedSupplier.entId || ''; // 保存供应商 entId
      }
    },
    
	// 判断是否显示当前库存列
	shouldShowPurcCnt(index) {
	  const row = this.medicineList[index];
	  
	  // 在详情、提交、审核、过单模式下不显示
	  if (['view', 'submit', 'review', 'pass'].includes(this.currentMode)) {
	    return false;
	  }
	  
	  // 在修改模式下
	  if (this.currentMode === 'edit') {
	    // 如果行处于锁定状态且不是编辑状态，不显示
	    if (row.isLocked && !row.isEditing) {
	      return false;
	    }
	    // 如果行处于编辑状态但没有选择药品，不显示
	    if (row.isEditing && !row.drugId) {
	      return false;
	    }
	  }
	  
	  return true;
	},
	
    // 处理药品选择变更
    handleDrugChange(dugInvyId, row, index) {
      console.log('药品选择变更 (dugInvyId):', dugInvyId, '行索引:', index);
      
      if (!dugInvyId) {
        console.log('清空药品选择');
        this.resetMedicineRow(row);
        row.hasChanged = this.checkRowChanged(row);
        return;
      }
      
      // 使用 dugInvyId 查找药品
      const selectedDrug = this.drugOptions.find(item => (item.invyId || item.dugInvyId) === dugInvyId);
      if (selectedDrug) {
        console.log('找到选中药品:', selectedDrug);
        
        // 填充药品信息
        row.drugId = selectedDrug.drugId; // 保留 drugId 以兼容其他逻辑
        row.drugName = selectedDrug.drugName;
        row.purcCnt = selectedDrug.purcCnt || '';
        row.pacCnt = selectedDrug.pacCnt || '';
        row.manuLotnum = selectedDrug.manuLotnum || '';
        row.prodentpName = selectedDrug.prodentpName || '';
        row.manuDate = selectedDrug.manuDate || '';
        row.expyDate = selectedDrug.expyDate || '';
        // 获取入库成本 - 从selectYFtoYKDrug接口返回的purcPric
        row.purcPric = selectedDrug.purcPric || '';
        row.salePric = selectedDrug.salePric || '';
        row.drugSpec = selectedDrug.drugSpec || '';
        row.dosUnt = selectedDrug.dosUnt || '';
        row.pacUnt = selectedDrug.pacUnt || '';
        // 关键：保存库存ID (确保一致)
        row.dugInvyId = selectedDrug.invyId || selectedDrug.dugInvyId || null;
		row.invyId = selectedDrug.invyId || selectedDrug.dugInvyId || null;
        console.log('保存库存ID:', row.dugInvyId);
        
        row.prodentpNameId = selectedDrug.prodentpNameId || null;
        row.unit = row.pacUnt; // 默认显示包装单位
        
        // 关键：获取加成方式和指定售价
        row.markUpId = selectedDrug.markUpId || 1;
        row.isFixPrice = selectedDrug.isFixPrice || 0;
        row.markUpMethodText = this.getMarkupMethodText(row.markUpId, row.isFixPrice);
        row.isFixedPriceText = row.isFixPrice === 1 ? '已指定' : '未指定';
        
        // 如果成本已有值，立即计算零售价
        if (row.currentOutCost && row.currentOutCost > 0) {
           this.calculateRetailPriceByMarkUp(row, row.currentOutCost);
        }
        
        // 关键：获取是否启用追溯码字段
        row.isBar = selectedDrug.isBar || 0;
        console.log('药品是否启用追溯码 (isBar):', row.isBar, '药品名称:', selectedDrug.drugName);
        
        // 清除追溯码相关数据
        row.traceCodes = [];
        row.tracCodeJson = '';
        
        // 清除验证状态，因为药品已更改
        row.verified = false;
        row.verificationResult = null;
        
        // 选择药品后，出库数量为空，所以当前出库成本和零售应为0
        row.currentOutCost = 0;
        row.currentOutSale = 0;
        
        // 计算当前出库成本和零售
        this.calculateRowAmounts(row);
        row.hasChanged = this.checkRowChanged(row);
        
        console.log(`药品${selectedDrug.drugName}信息已填充，isBar: ${row.isBar}, 入库成本:`, row.purcPric, '当前出库成本:', row.currentOutCost);
      } else {
        console.log('未找到对应药品，dugInvyId:', dugInvyId);
      }
    },
    
	getMarkupMethodText(markUpId, isFixPrice) {
	  const map = {
	    1: '比例加成',
	    2: '固定加成',
	    3: '手工比例加成',
	    4: '不加成'
	  };
	  return map[markUpId] || '未知';
	},
	
    // 处理出库数量变更
    handleQuantityChange(value, row, index) {
      // 验证只能输入大于0的正数
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue <= 0) {
        this.$message.warning('出库数量必须为大于0的数字');
        row.outQuantity = '';
        row.currentOutCost = 0;
        row.currentOutSale = 0;
        row.hasChanged = this.checkRowChanged(row);
        return;
      }
      
      // 检查是否为小数
      if (numValue % 1 !== 0) {
        // 如果是小数，设置为最小单位
        row.stockType = 1;
        row.unit = row.dosUnt;
      } else {
        // 如果是整数，保持原库存类型
        if (!row.stockType) {
          row.stockType = 2;
          row.unit = row.pacUnt;
        }
      }
      
      // 重新计算金额
      this.calculateRowAmounts(row);
      row.hasChanged = this.checkRowChanged(row);
      
      console.log('出库数量变更，当前出库成本:', row.currentOutCost, '当前出库零售:', row.currentOutSale);
      
      // 在修改模式下，如果行处于编辑状态，自动触发验证
      if (this.currentMode === 'edit' && row.isEditing && row.drugId && row.outQuantity && row.dugInvyId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoStockCheck(row, index, true);
          }, 300);
        });
      }
      // 新增模式保持原有逻辑
      else if (this.currentMode === 'add' && row.drugId && row.outQuantity && row.dugInvyId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoStockCheck(row, index, true);
          }, 300);
        });
      }
    },
    
    // 处理库存类型变更
    handleStockTypeChange(value, row) {
      console.log('库存类型变更:', value, '当前出库数量:', row.outQuantity);
      
      row.stockType = value;
      row.unit = value === 1 ? row.dosUnt : row.pacUnt;
      this.calculateRowAmounts(row);
      row.hasChanged = this.checkRowChanged(row);
      
      console.log('库存类型变更后，当前出库成本:', row.currentOutCost, '当前出库零售:', row.currentOutSale);
      
      // 如果已选择药品且有出库数量，自动调用库存验证
      if (row.drugId && row.outQuantity && row.dugInvyId) {
        // 只有在修改模式下才自动验证
        if (this.currentMode === 'edit' && row.isEditing) {
          this.autoStockCheck(row, this.medicineList.indexOf(row), true);
        }
        // 新增模式保持原有逻辑
        else if (this.currentMode === 'add') {
          this.$nextTick(() => {
            setTimeout(() => {
              this.autoStockCheck(row, this.medicineList.indexOf(row), true);
            }, 300);
          });
        }
      }
    },
    
	// 自动库存验证
	async autoStockCheck(row, index, isManual = false) {
	  if (!row.drugId || !row.outQuantity) {
	    return;
	  }
	  
	  // 检查是否有dugInvyId
	  if (!row.dugInvyId || !row.invyId) {
	    this.$message.warning('未获取到库存ID，请重新选择药品');
	    return;
	  }
	  
	  // 防止频繁调用
	  if (row.checkingStock) {
	    return;
	  }
	  
	  try {
	    row.checkingStock = true;
	    this.tableLoading = true;
	    
	    const params = {
	      amount: row.outQuantity, // 出库数量
	      invId: row.dugInvyId, // 库存ID
	      purcType: row.stockType // 库存类型
	    };
	    
	    console.log('自动库存验证参数:', params);
	    
	    const response = await docXYFOutJoin(params);
	    if (response && response.code === 200) {
	      // 验证成功
	      if (this.currentMode === 'edit' && row.isEditing) {
	        // 修改模式下，验证成功，锁定行并退出编辑状态
	        row.isLocked = true;
	        row.isEditing = false;
	        row.hasChanged = false;
	        row.originalData = JSON.parse(JSON.stringify(row));
	        
	        // 隐藏操作列中的保存按钮
	        this.editingRowIndex = -1;
	        
	        // this.$message.success(`已成功将${row.drugName}修改并锁定`);
	      } else if (this.currentMode === 'add') {
	        // 新增模式下，验证成功，标记为已验证
	        row.verified = true;
	        row.hasChanged = false;
	        
	        // this.$message.success(`已成功将${row.drugName}添加至出库明细表！`);
	      }
	      
	      // 验证成功后，更新金额字段
	      if (response.data && response.data.length > 0) {
	        const firstItem = response.data[0];
	        console.log('docXYFOutJoin接口返回的数据:', firstItem);
	        
	        // 更新入库成本 - 将接口返回的retnPric赋值到入库成本字段
	        row.purcPric = firstItem.retnPric || row.purcPric;
	        row.salePric = firstItem.salePric || row.salePric;
	        
	        // 计算当前出库成本 = 接口返回的retnPric * 接口返回的apllyAmt
	        const retnPric = parseFloat(firstItem.retnPric) || 0;
	        const apllyAmt = parseFloat(firstItem.apllyAmt) || parseFloat(row.outQuantity) || 0;
	        row.currentOutCost = retnPric * apllyAmt;
	        
	        // 计算当前出库零售 = 接口返回的salePric * 接口返回的apllyAmt
	        const salePric = parseFloat(firstItem.salePric) || 0;
	        row.currentOutSale = salePric * apllyAmt;
	        
	        console.log('验证成功，更新金额字段:', {
	          入库成本: row.purcPric,
	          接口返回的retnPric: retnPric,
	          接口返回的apllyAmt: apllyAmt,
	          当前出库成本: row.currentOutCost,
	          接口返回的salePric: salePric,
	          当前出库零售: row.currentOutSale
	        });
	      }
	    } else {
	      // 验证失败
	      this.$message.error(response?.message || '库存验证失败');
	      
	      if (this.currentMode === 'edit' && row.isEditing) {
	        // 修改模式下验证失败，保持编辑状态，不锁定
	        row.isLocked = false;
	        row.isEditing = true; // 保持编辑状态
	        row.hasChanged = true; // 保持有变化状态
	        
	        // 验证失败时不启用底部按钮
	        console.log('修改模式验证失败，保持编辑状态，不启用底部按钮');
	      } else if (this.currentMode === 'add') {
	        // 新增模式下验证失败
	        row.verified = false;
	        row.hasChanged = true;
	      }
	    }
	  } catch (error) {
	    console.error('自动库存验证失败:', error);
	    this.$message.error('库存验证失败，请稍后重试');
	    
	    if (this.currentMode === 'edit' && row.isEditing) {
	      row.isLocked = false;
	      row.isEditing = true; // 保持编辑状态
	      row.hasChanged = true; // 保持有变化状态
	    } else if (this.currentMode === 'add') {
	      row.verified = false;
	      row.hasChanged = true;
	    }
	  } finally {
	    row.checkingStock = false;
	    this.tableLoading = false;
	  }
	},
	
    // 计算当前行的出库成本和零售
	calculateRowAmounts(row) {
     const quantity = parseFloat(row.outQuantity) || 0;
     // 如果当前出库成本未设置，用入库成本计算
     if (!row.currentOutCost || row.currentOutCost === 0) {
       const costPrice = parseFloat(row.purcPric) || 0;
       row.currentOutCost = quantity * costPrice;
     }
     // 不在这里设置 currentOutSale，由专门逻辑处理
     row.totalOutCost = row.currentOutCost;
	},
    
    // 重置药品行
    resetMedicineRow(row) {
      row.drugId = null;
      row.drugName = '';
      row.purcCnt = '';
      row.outQuantity = '';
      row.stockType = 2;
      row.pacCnt = '';
      row.prodentpName = ''; // 注意字段名
      row.manuLotnum = '';
      row.manuDate = '';
      row.expyDate = '';
      row.purcPric = '';
      row.currentOutCost = '';
      row.salePric = '';
      row.currentOutSale = '';
      row.drugSpec = '';
      row.unit = '';
      row.dosUnt = '';
      row.pacUnt = '';
      row.dugInvyId = null;
	  row.invyId = null;
      row.prodentpNameId = null;
      row.hasChanged = this.checkRowChanged(row);
    },
    
    // 计算当前出库成本
    calculateCurrentOutCost(item) {
      const quantity = parseFloat(item.outQuantity) || 0;
      const costPrice = parseFloat(item.purcPric) || 0;
      return quantity * costPrice;
    },
    
    // 计算当前出库零售
    calculateCurrentOutSale(item) {
      const quantity = parseFloat(item.outQuantity) || 0;
      const salePrice = parseFloat(item.salePric) || 0;
      return quantity * salePrice;
    },
    
    // 检查行数据是否变化
    checkRowChanged(row) {
      if (!row.originalData) {
        // 如果没有原始数据，说明是新增行
        return !!(row.drugId || row.outQuantity);
      }
      
      // 比较关键字段是否变化
      return row.drugId !== row.originalData.drugId ||
             row.outQuantity !== row.originalData.outQuantity ||
             row.stockType !== row.originalData.stockType;
    },
    
	// 库存验证
	async handleStockCheck(row, index) {
	  if (!row.drugId || !row.outQuantity) {
	    this.$message.warning('请先选择药品并填写出库数量');
	    return;
	  }
	  
	  // 检查是否有dugInvyId
	  if (!row.dugInvyId || !row.invyId) {
	    this.$message.warning('未获取到库存ID，请重新选择药品');
	    return;
	  }
	  
	  try {
	    this.tableLoading = true;
	    const params = {
	      amount: row.outQuantity, // 出库数量
	      invyId: row.dugInvyId, // 库存ID
	      purcType: row.stockType // 库存类型
	    };
	    
	    console.log('库存验证参数:', params);
	    
	    const response = await docXYFOutJoin(params);
	    if (response && response.code === 200) {
	      // 库存验证成功，但不更新金额字段
	      // 只锁定行状态
	      row.isLocked = true;
	      row.isEditing = false;
	      row.hasChanged = false;
	      row.originalData = JSON.parse(JSON.stringify(row));
	      
	      this.$message.success(`已为${row.drugName}完成库存验证`);
	    } else {
	      this.$message.error(response.message || '库存验证失败');
	    }
	  } catch (error) {
	    console.error('库存验证失败:', error);
	    this.$message.error('库存验证失败');
	  } finally {
	    this.tableLoading = false;
	  }
	},
    
    // 修改行
    handleEditRow(row, index) {
      row.isEditing = true;
      row.hasChanged = false;
      row.originalData = JSON.parse(JSON.stringify(row));
      this.editingRowIndex = index;
    },
    
    // 保存编辑
    async handleSaveEdit(row, index) {
      if (!row.drugId || !row.outQuantity) {
        this.$message.warning('请先选择药品并填写出库数量');
        return;
      }
      
      // 检查是否有dugInvyId
      if (!row.dugInvyId || !row.invyId) {
        this.$message.warning('未获取到库存ID，请重新选择药品');
        return;
      }
      
      try {
        this.tableLoading = true;
        const params = {
          amount: row.outQuantity, // 出库数量
          invyId: row.dugInvyId, // 库存ID
          purcType: row.stockType // 库存类型
        };
        
        const response = await docXYFOutJoin(params);
        if (response && response.code === 200) {
          // 验证成功，锁定行并退出编辑状态
          row.isLocked = true;
          row.isEditing = false;
          row.hasChanged = false;
          row.originalData = JSON.parse(JSON.stringify(row));
          this.editingRowIndex = -1;
          
          // 验证成功后，更新金额字段
          if (response.data && response.data.length > 0) {
            const firstItem = response.data[0];
            console.log('保存编辑时接口返回的数据:', firstItem);
            
            // 更新入库成本 - 将接口返回的retnPric赋值到入库成本字段
            row.purcPric = firstItem.retnPric || row.purcPric;
            row.salePric = firstItem.salePric || row.salePric;
            
            // 计算当前出库成本 = 接口返回的retnPric * 接口返回的apllyAmt
            const retnPric = parseFloat(firstItem.retnPric) || 0;
            const apllyAmt = parseFloat(firstItem.apllyAmt) || 0;
            row.currentOutCost = retnPric * apllyAmt;
            
            // 计算当前出库零售 = 接口返回的salePric * 接口返回的apllyAmt
            const salePric = parseFloat(firstItem.salePric) || 0;
            row.currentOutSale = salePric * apllyAmt;
          }
          
          this.$message.success('修改已保存');
        } else {
          this.$message.error(response.message || '库存验证失败，保存未成功');
          
          // 验证失败，保持编辑状态，不锁定
          row.isLocked = false;
          row.isEditing = true; // 保持编辑状态
          row.hasChanged = true; // 保持有变化状态
        }
      } catch (error) {
        console.error('保存编辑失败:', error);
        this.$message.error('保存编辑失败');
        
        // 异常时也保持编辑状态，不锁定
        row.isLocked = false;
        row.isEditing = true;
        row.hasChanged = true;
      } finally {
        this.tableLoading = false;
      }
    },
    
    // 取消编辑
    handleCancelEdit(row, index) {
      if (row.originalData) {
        // 恢复原始数据
        Object.assign(row, row.originalData);
      }
      row.isEditing = false;
      row.hasChanged = false;
      this.editingRowIndex = -1;
    },
    
    // 移除行
    handleRemoveRow(row, index) {
      if (!row.drugId) {
        // 如果未选择药品，直接移除
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
        return;
      }
      
      // 如果已选择药品，弹出确认提示
      this.$confirm(
        '当前出库表格中您已选择了出库药库，可尝试重新填写其对应的明细，或者点击确定移除此行，进行重新编辑。',
        '确认移除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
      }).catch(() => {
        // 用户取消移除
      });
    },
    
    // 格式化金额（智能小数位数处理，限制最多8位小数）
    formatAmount(amount) {
      if (amount === undefined || amount === null || amount === '') return '0.00';
      
      // 转换为数字
      const num = parseFloat(amount);
      if (isNaN(num)) return '0.00';
      
      // 检查是否为整数
      if (num % 1 === 0) {
        // 整数，显示两位小数
        const fixedNum = num.toFixed(2);
        const parts = fixedNum.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      } else {
        // 有小数
        // 转换为字符串，保留最多8位小数
        const numStr = num.toString();
        let parts = numStr.split('.');
        
        // 如果小数部分超过8位，截取前8位
        if (parts[1] && parts[1].length > 8) {
          parts[1] = parts[1].substring(0, 8);
        }
        
        // 去掉末尾的0
        if (parts[1]) {
          parts[1] = parts[1].replace(/0+$/, '');
          // 如果去掉0后没有小数了，添加.00
          if (parts[1] === '') {
            parts[1] = '00';
          }
        } else {
          parts[1] = '00';
        }
        
        // 整数部分添加千位分隔符
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        
        return parts.join('.');
      }
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '--';
      if (typeof date === 'string') {
        return date.split(' ')[0]; // 只取日期部分
      }
      if (typeof date === 'number') {
        return new Date(date).toISOString().split('T')[0];
      }
      return '--';
    },
    
    // 验证表单
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.purchaseForm.validate((valid) => {
          if (!valid) {
            this.$message.error('请填写完整的采购信息');
            reject(new Error('表单验证失败'));
            return;
          }
          
          if (this.medicineList.length === 0) {
            this.$message.error('请至少添加一条药品明细');
            reject(new Error('药品明细为空'));
            return;
          }
          
          // 验证药品明细
          // for (let i = 0; i < this.medicineList.length; i++) {
          //   const item = this.medicineList[i];
          //   if (!item.drugId) {
          //     this.$message.error(`第${i + 1}行：请选择药品`);
          //     reject(new Error(`第${i + 1}行药品未选择`));
          //     return;
          //   }
            
          //   if (!item.outQuantity || parseFloat(item.outQuantity) <= 0) {
          //     this.$message.error(`第${i + 1}行：请输入有效的出库数量`);
          //     reject(new Error(`第${i + 1}行出库数量无效`));
          //     return;
          //   }
            
          //   if (!item.isLocked) {
          //     this.$message.error(`第${i + 1}行：请先完成库存验证`);
          //     reject(new Error(`第${i + 1}行未完成库存验证`));
          //     return;
          //   }
          // }
          
          resolve();
        });
      });
    },
    
    // 准备提交数据
    prepareSubmitData(state) {
      // 计算总成本
      const costAmt = this.medicineList.reduce((total, item) => {
        const retnAmt = parseFloat(item.currentOutCost) || 0;
        return total + retnAmt;
      }, 0);
      
      // 计算总零售
      const saleAmt = this.medicineList.reduce((total, item) => {
        const saleAmtItem = parseFloat(item.currentOutSale) || 0;
        return total + saleAmtItem;
      }, 0);
      
      return {
        costAmt: costAmt,
        list: this.medicineList.map(item => {
          let tracCodeJson = [];
          
          if (item.isBar === 1 || item.isBar === "1" || item.isBar === true) {
            console.log(`处理药品 ${item.drugName} 的追溯码，isBar:`, item.isBar);
            
            if (item.traceCodes && item.traceCodes.length > 0) {
              console.log(`从traceCodes提取 ${item.traceCodes.length} 个追溯码`);
              item.traceCodes.forEach(traceCode => {
                if (traceCode.traceCode) {
                  tracCodeJson.push({
                    barcode: traceCode.traceCode,
                    chgCnt: item.pacCnt || 1,
                    manuLotnum: item.manuLotnum || ''   // 新增：生产批号
                  });
                }
              });
            }
            
            if (tracCodeJson.length === 0 && item.tracCodeJson) {
              try {
                const parsedCodes = JSON.parse(item.tracCodeJson);
                if (Array.isArray(parsedCodes) && parsedCodes.length > 0) {
                  tracCodeJson = parsedCodes.map(code => ({
                    barcode: code.barcode,
                    chgCnt: code.chgCnt || item.pacCnt || 1,
                    manuLotnum: code.manuLotnum || item.manuLotnum || ''   // 保留已有或使用当前行的批号
                  }));
                  console.log(`从tracCodeJson字段解析到 ${tracCodeJson.length} 个追溯码`);
                }
              } catch (error) {
                console.error('解析tracCodeJson失败:', error);
              }
            }
          }
          
          console.log(`药品 ${item.drugName} 的追溯码数组:`, tracCodeJson);
          const tracCodeJsonString = tracCodeJson.length > 0 ? JSON.stringify(tracCodeJson) : '';
          console.log(`药品 ${item.drugName} 的追溯码JSON字符串:`, tracCodeJsonString);
          
          return {
            apllyAmt: parseFloat(item.outQuantity) || 0,
            drugId: item.drugId,
            drugName: item.drugName,
            drugSpec: item.drugSpec,
            dugInvyId: item.dugInvyId || 0,
			invId: item.invyId || 0,
            manuLotnum: item.manuLotnum,
            prodentpName: item.prodentpName,
            prodentpNameId: item.prodentpNameId || 0,
            purcType: item.stockType,
            retnAmt: parseFloat(item.currentOutCost) || 0,
            retnPric: parseFloat(item.purcPric) || 0,
            saleAmt: parseFloat(item.currentOutSale) || 0,
            salePric: parseFloat(item.salePric) || 0,
            unt: item.stockType === 1 ? item.dosUnt : item.pacUnt,
            isBar: item.isBar || 0,
            traceCodes: item.traceCodes || [],
            tracCodeJson: tracCodeJsonString
          };
        }),
        remarks: this.purchaseForm.remarks,
        retnTypeId: this.purchaseForm.outTypeId,
        deptId: this.purchaseForm.deptId,
        saleAmt: saleAmt,
        phayId: this.purchaseForm.warehouseId,
        state: state,
        supplyCandidateId: this.purchaseForm.supplierId
      };
    },
    
    // 保存草稿
    async handleSaveDraft() {
      try {
        this.submitLoading = true;
        
        // 验证表单
        const valid = await this.$refs.purchaseForm.validate();
        if (!valid) {
          throw new Error('表单验证失败');
        }
        
        // 验证药品明细
        if (this.medicineList.length === 0) {
          throw new Error('请至少添加一种药品');
        }
        
        // 准备提交数据
        const submitData = this.prepareSubmitData(0); // 0表示草稿状态
        console.log('保存草稿，提交数据:', submitData);
        console.log('tracCodeJson:', submitData.tracCodeJson);
        
        // 调用保存草稿接口
        const response = await addXYFOutbound(submitData);
        
        if (response && response.code === 200) {
          this.$message.success('保存草稿成功');
          this.handleClose();
          this.$emit('success');
        } else {
          this.$message.error(response?.message || '保存草稿失败');
        }
      } catch (error) {
        console.error('保存草稿失败:', error);
        this.$message.error('保存草稿失败: ' + error.message);
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 保存提交
    async handleSaveSubmit() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(2); // 已提交状态
        
        let response = null;
        if (this.currentMode === 'add') {
          response = await addXYFOutbound(submitData);
        } else if (this.currentMode === 'edit') {
          response = await editXYFdocOut({
            ...submitData,
            id: this.rowData.id
          });
        }
        
        if (response && response.code === 200) {
          const drugNames = this.medicineList.map(item => item.drugName).join('、');
          this.$message.success(`${this.purchaseForm.businessDate} - ${drugNames}出库单 已完成提交状态的创建！`);
          this.$emit('success', {
            ...response.data,
            warehouseId: this.purchaseForm.warehouseId
          });
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存提交失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('保存提交失败:', error);
          this.$message.error('保存提交失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 提交审核
    async handleSubmitReview() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(2); // 已提交状态
        
        const response = await toXYFRetnExamine({
          ...submitData,
          id: this.rowData.id
        });
        
        if (response && response.code === 200) {
          this.$message.success('提交审核成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '提交审核失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('提交审核失败:', error);
          this.$message.error('提交审核失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 确认审核
    async handleReviewPass() {
      try {
        this.submitLoading = true;
        
        const response = await toXYFRetnExamine({
          id: this.rowData.id,
          state: 4 // 已审核状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('确认审核成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '确认审核失败');
        }
      } catch (error) {
        console.error('确认审核失败:', error);
        this.$message.error('确认审核失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 处理过单出库
    async handlePassOutbound() {
      try {
        this.submitLoading = true;
        
        // 过单出库不需要验证表单和药品明细，因为已经是审核通过的状态
        // 但是我们可以检查一下是否有单据ID
        if (!this.rowData.id) {
          throw new Error('未找到单据ID，无法过单出库');
        }
        
        console.log('开始过单出库，单据ID:', this.rowData.id);
        console.log('当前药品列表:', this.medicineList);
        
        // 直接打开步骤进度条模态框
        console.log('打开步骤进度条模态框');
        this.handleTraceCodeUploadProcess();
        
      } catch (error) {
        console.error('过单出库失败:', error);
        this.$message.error('过单出库失败: ' + error.message);
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 处理追溯码上传进度流程
    async handleTraceCodeUploadProcess() {
      console.log('开始处理追溯码上传进度流程');
      
      // 重置状态
      this.resetPassProgress();
      
      // 打开进度模态框
      this.passProgressDialogVisible = true;
      this.showCloseButton = false;
      this.showRetryButton = false;
      this.retryLoading = false;
      this.retryTips = '';
      this.totalProgress = 0;
      
      console.log('已设置passProgressDialogVisible为true');
      
      try {
        // 第一步：正在确认过单单据
        await this.executeStepWithProgress(0, async () => {
          this.updateProgressStep(0, 'process', '正在处理中...');
          this.updateStepProgress(0, 0);
          
          // 调用过单接口，状态为5
          const response = await toXYFRetnExamine({
            id: this.rowData.id,
            state: 5 // 已过单出库状态
          });
          
          if (response && response.code === 200) {
            this.updateStepProgress(0, 100);
            this.updateProgressStep(0, 'finish', '单据过单成功');
            this.updateTotalProgress(16.7); // 第一步完成，总进度16.7%
            await this.delay(1000);
          } else {
            throw new Error(response?.message || '确认过单单据失败');
          }
        });
        
        // 第二步：正在检查是否需要上传追溯码
        await this.executeStepWithProgress(1, async () => {
          this.updateProgressStep(1, 'process', '检查中...');
          this.updateStepProgress(1, 0);
          
          // 检查是否需要上传追溯码
          await this.checkNeedUploadTraceCode();
          
          // 获取需要上传的药品列表
          this.needUploadDrugs = this.getNeedUploadDrugs();
          
          if (this.needUploadTraceCode) {
            this.updateStepProgress(1, 100);
            this.updateProgressStep(1, 'finish', `发现 ${this.needUploadDrugs.length} 个药品需要上传追溯码`);
            this.updateTotalProgress(33.4); // 第二步完成，总进度33.4%
          } else {
            this.updateStepProgress(1, 100);
            this.updateProgressStep(1, 'finish', '本次单据无需上传追溯码');
            this.updateTotalProgress(33.4);
          }
        });
        
        if (this.needUploadTraceCode) {
          // 第三步：正在接入码上放心平台
          await this.executeStepWithProgress(2, async () => {
            this.updateProgressStep(2, 'process', '连接中...');
            this.updateStepProgress(2, 0);
            
            // 获取系统参数
            const success = await this.getSystemParameters();
            
            if (success && this.msfxEntId) {
              this.updateStepProgress(2, 100);
              this.updateProgressStep(2, 'finish', '平台连接成功，已获取码上放心entid');
              this.updateTotalProgress(50.1);
            } else {
              this.updateStepProgress(2, 100);
              this.updateProgressStep(2, 'finish', '获取系统参数失败，将使用默认值');
              this.updateTotalProgress(50.1);
            }
          });
          
          // 第四步：上传追溯码
          await this.executeStepWithProgress(3, async () => {
            this.updateProgressStep(3, 'process', '上传中...');
            this.updateStepProgress(3, 0);
            
            // 提取追溯码
            await this.extractTraceCodes();
            
            // 更新进度
            this.updateStepProgress(3, 30);
            
            // 上传追溯码
            const uploadResult = await this.uploadTraceCodes();
            
            if (uploadResult.success) {
              this.updateStepProgress(3, 100);
              const docNum = this.rowData.docNum || '';
              this.updateProgressStep(3, 'finish', `出库单据 ${docNum} - ${this.traceCodeCount} 个追溯码已成功上传至码上放心平台`);
              this.updateTotalProgress(66.8); // 第四步完成，总进度66.8%
            } else {
              // 上传失败，设置重新补传按钮
              this.updateStepProgress(3, 100);
              this.updateProgressStep(3, 'error', uploadResult.message);
              this.passProgressSteps[3].showRetryButton = true;
              this.showRetryButton = true;
              this.retryTips = uploadResult.message || '上传失败，请点击重新补传';
              throw new Error('上传追溯码失败');
            }
          });
        } else {
          // 不需要上传追溯码，跳过第三、四步
          await this.executeStepWithProgress(2, async () => {
            this.updateStepProgress(2, 100);
            this.updateProgressStep(2, 'finish', '无需接入码上放心平台');
            this.updateTotalProgress(50.1);
          });
          
          await this.executeStepWithProgress(3, async () => {
            this.updateStepProgress(3, 100);
            this.updateProgressStep(3, 'finish', '无需上传追溯码');
            this.updateTotalProgress(66.8);
          });
        }
        
        // 第五步：已完成过单出库
        await this.executeStepWithProgress(4, async () => {
          this.updateProgressStep(4, 'process', '处理中...');
          this.updateStepProgress(4, 0);
          
          await this.delay(1000);
          this.updateStepProgress(4, 100);
          this.updateProgressStep(4, 'finish', '过单出库操作已完成');
          this.updateTotalProgress(83.5); // 第五步完成，总进度83.5%
        });
        
        // 第六步：已完成
        await this.executeStepWithProgress(5, async () => {
          this.updateProgressStep(5, 'process', '流程即将完成...');
          this.updateStepProgress(5, 0);
          
          await this.delay(1000);
          this.updateStepProgress(5, 100);
          this.updateProgressStep(5, 'finish', '所有步骤已完成');
          this.updateTotalProgress(100); // 第六步完成，总进度100%
          
          // 只有所有步骤都成功完成时才自动关闭模态框
          console.log('所有步骤完成，准备关闭模态框');
          setTimeout(() => {
            this.passProgressDialogVisible = false;
            this.handleClose();
            this.$emit('success');
          }, 2000);
        });
        
      } catch (error) {
        console.error('追溯码上传流程出错:', error);
        this.showCloseButton = true;
      }
    },
    
	// 获取需要上传追溯码的药品列表
	getNeedUploadDrugs() {
	  const drugs = [];
	  
	  this.medicineList.forEach(item => {
	    if (item.isBar === 1) {
	      let hasTraceCodes = false;
	      
	      // 检查traceCodes
	      if (item.traceCodes && item.traceCodes.length > 0) {
	        hasTraceCodes = true;
	      }
	      
	      // 检查tracCodeJson
	      if (item.tracCodeJson) {
	        try {
	          const traceCodes = JSON.parse(item.tracCodeJson);
	          if (traceCodes.length > 0) {
	            hasTraceCodes = true;
	          }
	        } catch (error) {
	          console.error('解析tracCodeJson失败:', error);
	        }
	      }
	      
	      if (hasTraceCodes) {
	        drugs.push({
	          drugName: item.drugName,
	          drugId: item.drugId,
	          traceCodeCount: this.getTraceCodeCountForDrug(item)
	        });
	      }
	    }
	  });
	  
	  return drugs;
	},
	
	// 获取药品的追溯码数量
	getTraceCodeCountForDrug(item) {
	  let count = 0;
	  
	  if (item.traceCodes && item.traceCodes.length > 0) {
	    count = item.traceCodes.length;
	  } else if (item.tracCodeJson) {
	    try {
	      const traceCodes = JSON.parse(item.tracCodeJson);
	      count = traceCodes.length;
	    } catch (error) {
	      console.error('解析tracCodeJson失败:', error);
	    }
	  }
	  
	  return count;
	},
	
	// 更新步骤进度
	updateStepProgress(stepIndex, progress) {
	  if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
	    this.passProgressSteps[stepIndex].progress = progress;
	  }
	},
	
	// 更新总进度
	updateTotalProgress(progress) {
	  this.totalProgress = Math.min(100, Math.max(0, progress));
	},
	
	// 格式化总进度显示
	formatTotalProgress(percentage) {
	  return `总进度: ${percentage.toFixed(0)}%`;
	},
	
    // 上传追溯码
    async uploadTraceCodes() {
      if (!this.traceCodeString) {
        return { success: true, message: '无追溯码需要上传' };
      }
    
      try {
        const docNum = this.rowData?.docNum || '';
        if (!docNum) {
          return { success: false, message: '未获取到单据编号' };
        }
    
        // 步骤1：获取供应商的 entId（作为 fromUserId）
        const fromUserId = this.purchaseForm?.entId || this.rowData?.entId || '';
        if (!fromUserId) {
          console.warn('未获取到供应商 entId，将使用空值');
        }
    
        // 步骤2：获取系统参数中的码上放心 entId（作为 toUserId）
        const toUserId = this.msfxEntId || '';
        if (!toUserId) {
          console.warn('未获取到码上放心 entId，将使用空值');
        }
    
        // 步骤3：提取追溯码字符串
        const traceCodesToUpload = this.traceCodeString.replace(/,\s*/g, ',');
    
        // 步骤4：构建上传参数
        const uploadData = {
          billType: 202,
          bizNum: docNum,
          fromUserId: fromUserId, // 供应商的 entId
          physicType: 3,
          toUserId: toUserId,     // 系统参数中的码上放心 entId
          traceCodes: traceCodesToUpload
        };
    
        console.log('上传追溯码参数:', uploadData);
    
        // 步骤5：调用上传接口
        const response = await msfxUploadInoutBill(uploadData);
        console.log('上传接口返回:', response);
    
        if (response.code === 200) {
          return { success: true, message: '上传成功' };
        } else {
          return { success: false, message: response.message || response.msg || '上传失败' };
        }
      } catch (error) {
        console.error('上传追溯码失败:', error);
        return { success: false, message: error.message || '网络错误' };
      }
    },
    
    // 处理重新补传
    async handleRetryUpload() {
      try {
        console.log('开始重新补传');
    
        // 重置步骤状态
        this.passCurrentStep = 3;
        this.passProgressSteps[3].status = 'process';
        this.passProgressSteps[3].description = '';
        this.passProgressSteps[3].progress = 0;
        this.passProgressSteps[3].showRetryButton = false;
    
        const docNum = this.rowData?.docNum || '';
        if (!docNum) {
          throw new Error('未获取到单据编号');
        }
    
        // 步骤1：获取供应商的 entId（作为 fromUserId）
        const fromUserId = this.purchaseForm?.entId || this.rowData?.entId || '';
        if (!fromUserId) {
          console.warn('重新补传-未获取到供应商 entId，将使用空值');
        }
    
        // 步骤2：获取系统参数中的码上放心 entId（作为 toUserId）
        const toUserId = this.msfxEntId || '';
        if (!toUserId) {
          console.warn('重新补传-未获取到码上放心 entId，将使用空值');
        }
    
        // 步骤3：提取追溯码字符串
        const traceCodesToUpload = this.traceCodeString.replace(/,\s*/g, ',');
    
        // 步骤4：构建上传参数
        const uploadData = {
          billType: 202,
          bizNum: docNum,
          fromUserId: fromUserId, // 供应商的 entId
          physicType: 3,
          toUserId: toUserId,     // 系统参数中的码上放心 entId
          traceCodes: traceCodesToUpload
        };
    
        console.log('重新补传-上传参数:', uploadData);
    
        // 步骤5：调用上传接口
        const response = await msfxUploadInoutBill(uploadData);
        console.log('重新补传-上传接口返回:', response);
    
        if (response.code === 200) {
          // 上传成功，更新步骤状态
          this.passProgressSteps[3].status = 'finish';
          this.passProgressSteps[3].description = `出库单据 ${docNum} - ${this.traceCodeCount} 个追溯码已成功上传至码上放心平台`;
          this.passProgressSteps[3].progress = 100;
    
          // 继续后续步骤
          await this.continueProgressAfterRetry();
        } else {
          // 上传失败，显示重试按钮
          this.passProgressSteps[3].status = 'error';
          this.passProgressSteps[3].description = response.message || '上传失败';
          this.passProgressSteps[3].showRetryButton = true;
          this.showRetryButton = true;
          this.retryTips = response.message || '上传失败，请点击重新补传';
        }
      } catch (error) {
        console.error('重新补传失败:', error);
        this.passProgressSteps[3].status = 'error';
        this.passProgressSteps[3].description = error.message || '重新补传失败';
        this.passProgressSteps[3].showRetryButton = true;
        this.showRetryButton = true;
      }
    },
    
    // 重新补传成功后继续执行后续步骤
    async continueProgressAfterRetry() {
      try {
        // 第五步：已完成过单出库
        await this.executeStepWithProgress(4, async () => {
          this.updateStepDetail(4, '已完成过单出库', 'process', '处理中...');
          
          await this.delay(1000);
          this.updateStepDetail(4, '已完成过单出库', 'finish', '过单出库操作已完成');
        });
        
        // 第六步：已完成
        await this.executeStepWithProgress(5, async () => {
          this.updateStepDetail(5, '已完成', 'process', '流程即将完成...');
          
          await this.delay(1000);
          this.updateStepDetail(5, '已完成', 'finish', '所有步骤已完成');
          
          // 只有所有步骤都成功完成时才自动关闭模态框
          console.log('所有步骤完成，准备关闭模态框');
          setTimeout(() => {
            this.passProgressDialogVisible = false;
            this.handleClose();
            this.$emit('success');
          }, 2000);
        });
        
      } catch (error) {
        console.error('继续执行后续步骤失败:', error);
        this.showCloseButton = true;
      }
    },
    
    // 更新步骤详情
    updateStepDetail(stepIndex, title, status, description = '') {
      if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
        this.passProgressSteps[stepIndex].title = title;
        this.passProgressSteps[stepIndex].status = status;
        this.passProgressSteps[stepIndex].description = description;
        
        // 更新当前步骤详情
        this.currentStepDetail = {
          title: title,
          status: status,
          description: description,
          statusClass: this.getStatusClass(status)
        };
      }
    },
    
    // 获取状态样式类
    getStatusClass(status) {
      switch (status) {
        case 'finish':
        case 'success':
          return 'status-success';
        case 'error':
          return 'status-error';
        case 'process':
          return 'status-process';
        default:
          return 'status-wait';
      }
    },
    
    // 重置进度状态
    resetPassProgress() {
      console.log('重置进度状态');
      this.passCurrentStep = 0;
      this.passProgressSteps = this.passProgressSteps.map((step, index) => ({
        ...step,
        status: index === 0 ? 'process' : 'wait',
        description: ''
      }));
      this.currentStepDetail = null;
    },
    
    // 更新进度步骤
    updateProgressStep(stepIndex, status, description = '') {
      if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
        this.passProgressSteps[stepIndex].status = status;
        this.passProgressSteps[stepIndex].description = description;
        
        if (status === 'finish' && stepIndex < this.passProgressSteps.length - 1) {
          this.passCurrentStep = stepIndex + 1;
          this.passProgressSteps[stepIndex + 1].status = 'process';
        } else if (status === 'error') {
          // 步骤出错时，停止后续步骤
          this.passCurrentStep = stepIndex;
        }
      }
    },
    
    // 关闭进度对话框
    handleCloseProgressDialog() {
      this.passProgressDialogVisible = false;
      this.showCloseButton = false;
      this.showRetryButton = false;
      this.retryLoading = false;
      this.retryTips = '';
    },
    
    // 更新步骤重试按钮
    updateStepRetryButton(stepIndex, show, loading = false) {
      if (stepIndex >= 0 && stepIndex < this.passProgressSteps.length) {
        this.passProgressSteps[stepIndex].showRetryButton = show;
        this.passProgressSteps[stepIndex].retryLoading = loading;
      }
    },
    
    // 执行步骤并更新进度
    async executeStepWithProgress(stepIndex, stepFunction) {
      try {
        this.updateProgressStep(stepIndex, 'process');
        await stepFunction();
      } catch (error) {
        console.error(`步骤${stepIndex}执行失败:`, error);
        this.updateProgressStep(stepIndex, 'error', error.message);
        throw error;
      }
    },
    
    // 延迟函数
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    
    // 获取系统参数
    async getSystemParameters() {
      try {
        console.log('开始获取系统参数列表');
        
        const response = await getSystemList();
        console.log('系统参数接口返回:', response);
        
        if (response && response.code === 200 && response.data) {
          this.systemParameterList = response.data;
          console.log('系统参数列表:', this.systemParameterList);
          
          // 查找码上放心entid
          this.findMsfxEntId();
          
          return true;
        } else {
          console.warn('获取系统参数失败:', response?.message);
          return false;
        }
      } catch (error) {
        console.error('获取系统参数异常:', error);
        return false;
      }
    },
    
    // 查找码上放心entid
    findMsfxEntId() {
      if (!this.systemParameterList || this.systemParameterList.length === 0) {
        console.warn('系统参数列表为空');
        this.msfxEntId = '';
        return;
      }
      
      console.log('开始查找码上放心entid');
      
      // 查找name为"码上放心entid"的参数
      const msfxParam = this.systemParameterList.find(param => 
        param.name && param.name.trim() === '码上放心entid'
      );
      
      if (msfxParam && msfxParam.value) {
        this.msfxEntId = msfxParam.value.trim();
        console.log('找到码上放心entid:', this.msfxEntId);
      } else {
        console.warn('未找到码上放心entid参数');
        this.msfxEntId = '';
        
        // 尝试其他可能的名称
        const possibleNames = ['码上放心entid', 'msfxEntId', 'ent_id', 'entId', '码上放心_entid'];
        for (const name of possibleNames) {
          const param = this.systemParameterList.find(p => 
            p.name && p.name.trim().toLowerCase() === name.toLowerCase()
          );
          if (param && param.value) {
            this.msfxEntId = param.value.trim();
            console.log(`通过别名"${name}"找到码上放心entid:`, this.msfxEntId);
            break;
          }
        }
      }
    },
    
	// 处理追溯码输入框失焦事件
	async handleTraceCodeBlur(row, index) {
	  console.log('追溯码输入框失焦，行索引:', index, '追溯码:', row.traceCode);
	  
	  if (!row.traceCode || row.traceCode.trim() === '') {
	    console.log('追溯码为空，跳过验证');
	    row.validationStatus = 'pending';
	    row.validationResult = null;
	    this.traceCodeValidationVisible = false;
	    this.enableConfirmButton = false;
	    return;
	  }
	  
	  const traceCode = row.traceCode.trim();
	  console.log('开始验证追溯码:', traceCode);
	  
	  try {
	    // 设置验证状态
	    row.validationStatus = 'pending';
	    row.isVerifying = true;
	    this.currentValidatingRowIndex = index;
	    
	    // 重置验证结果
	    row.validationResult = null;
	    row.drugInfoFromApi = null;
	    row.msfxDetailResult = null;
	    row.getSomeWareResult = null;
	    this.traceCodeValidationResult = null;
	    this.getSomeWareData = null;
	    
	    // 显示验证结果区域
	    this.traceCodeValidationVisible = true;
	    
	    // 1. 调用msfxCodeDetail接口
	    console.log('调用msfxCodeDetail接口，追溯码:', traceCode);
	    const msfxResponse = await msfxCodeDetail({
	      codes: traceCode
	    });
	    
	    console.log('msfxCodeDetail接口返回:', msfxResponse);
	    
	    if (!msfxResponse || msfxResponse.code !== 200 || !msfxResponse.data || msfxResponse.data.length === 0) {
	      throw new Error('未查询到该追溯码的信息');
	    }
	    
	    const traceCodeData = msfxResponse.data[0];
	    row.msfxDetailResult = traceCodeData;
	    
	    // 提取drugEntBaseDTO
	    const drugEntBaseDTO = traceCodeData.drugEntBaseDTO || {};
	    
	    // 提取药品名称
	    const drugName = drugEntBaseDTO.physicName || '';
	    if (!drugName) {
	      throw new Error('未从追溯码中提取到药品名称');
	    }
	    
	    // 提取包装数量
	    const prepnSpec = drugEntBaseDTO.prepnSpec || '1';
	    const pacCntFromTraceCode = this.extractNumberFromString(prepnSpec) || 1;
	    
	    console.log('从msfx接口提取的数据:', { drugName, prepnSpec, pacCntFromTraceCode });
	    
	    // 提取其他需要显示的字段
	    const approvalLicenceNo = drugEntBaseDTO.approvalLicenceNo || '';
	    const expireDate = drugEntBaseDTO.expireDate || '';
	    
	    // 保存接口返回的药品信息
	    row.drugInfoFromApi = {
	      drugName,
	      prepnSpec,
	      pacCnt: pacCntFromTraceCode,
	      approvalLicenceNo,
	      expireDate
	    };
	    
	    // 2. 调用getSomeWare接口
	    console.log('调用getSomeWare接口，参数:', { drugName, pacCnt: pacCntFromTraceCode });
	    const getSomeWareResponse = await getSomeWare({
	      drugName: drugName,
	      pacCnt: pacCntFromTraceCode
	    });
	    
	    console.log('getSomeWare接口返回:', getSomeWareResponse);
	    
	    if (!getSomeWareResponse) {
	      throw new Error('getSomeWare接口调用失败');
	    }
	    
	    row.getSomeWareResult = getSomeWareResponse;
	    
	    if (getSomeWareResponse.code !== 200) {
	      throw new Error(getSomeWareResponse.message || 'getSomeWare接口返回错误');
	    }
	    
	    const getSomeWareData = getSomeWareResponse.data || [];
	    
	    // 检查药品是否存在
	    if (!getSomeWareData || getSomeWareData.length === 0 || getSomeWareData === '') {
	      row.validationStatus = 'error';
	      row.validationResult = {
	        type: 'warning',
	        message: '录入的追溯码对应的药品不存在于本系统的基本药品目录中！请先检查追溯码或去药品目录进行该对应药品信息的维护！',
	        drugNameFromMsfx: drugName,
	        pacCntFromMsfx: pacCntFromTraceCode,
	        drugNameFromOuterMedicine: this.currentTraceMedicine?.drugName || '',
	        pacCntFromOuterMedicine: this.currentTraceMedicine?.pacCnt || 1
	      };
	      this.getSomeWareData = null;
	      this.enableConfirmButton = false;
	    } else {
	      // 药品存在，进行比较
	      const drugData = getSomeWareData || {};
	      const drugNameFromGetSomeWare = drugData.drugName || '';
	      const pacCntFromGetSomeWare = drugData.pacCnt || 1;
	      
	      console.log('从getSomeWare接口返回的药品信息:', {
	        药品名称: drugNameFromGetSomeWare,
	        包装数量: pacCntFromGetSomeWare
	      });
	      
	      // 获取外部选择的药品信息
	      const outerDrugName = this.currentTraceMedicine?.drugName || '';
	      const outerPacCnt = this.currentTraceMedicine?.pacCnt || 1;
	      
	      console.log('外部选择的药品信息:', {
	        药品名称: outerDrugName,
	        包装数量: outerPacCnt
	      });
	      
	      // 获取当前追溯码表格行的药品信息
	      const currentRowDrugName = row.drugName || '';
	      const currentRowAvailableQty = row.availableQty || 1;
	      
	      console.log('当前追溯码表格行的药品信息:', {
	        药品名称: currentRowDrugName,
	        可用数量: currentRowAvailableQty
	      });
	      
	      // 关键修改：比对逻辑
	      // 1. 比较getSomeWare返回的药品名称与外部药品名称
	      const isDrugNameMatch = drugNameFromGetSomeWare.toLowerCase() === outerDrugName.toLowerCase();
	      
	      // 2. 比较当前追溯码行的可用数量与外部药品的包装数量
	      const isPacCntMatch = Number(currentRowAvailableQty) === Number(outerPacCnt);
	      
	      const isMatch = isDrugNameMatch && isPacCntMatch;
	      
	      console.log('药品信息比对:', {
	        接口返回的药品名称: drugNameFromGetSomeWare,
	        外部药品名称: outerDrugName,
	        药品名称是否匹配: isDrugNameMatch,
	        当前追溯码行可用数量: currentRowAvailableQty,
	        外部药品包装数量: outerPacCnt,
	        包装数量是否匹配: isPacCntMatch,
	        总体是否匹配: isMatch
	      });
	      
	      if (isMatch) {
	        row.validationStatus = 'success';
	        row.validationResult = {
	          type: 'success',
	          message: '该追溯码验证正确√',
	          drugNameFromGetSomeWare: drugNameFromGetSomeWare,
	          pacCntFromGetSomeWare: pacCntFromGetSomeWare,
	          drugNameFromOuterMedicine: outerDrugName,
	          pacCntFromOuterMedicine: outerPacCnt,
	          drugNameFromCurrentRow: currentRowDrugName,
	          availableQtyFromCurrentRow: currentRowAvailableQty
	        };
	        
	        // 启用模态框底部的确定按钮
	        this.enableConfirmButton = true;
	        console.log('验证成功，启用确定按钮');
	      } else {
	        row.validationStatus = 'error';
	        let errorMessage = '';
	        
	        if (!isDrugNameMatch && !isPacCntMatch) {
	          errorMessage = '药品名称和包装数量均不匹配！请检查追溯码对应的药品与当前药品是否一致。';
	        } else if (!isDrugNameMatch) {
	          errorMessage = '药品名称不匹配！当前追溯码对应的药品与需要出库的药品不一致。';
	        } else if (!isPacCntMatch) {
	          errorMessage = '包装数量不匹配！当前追溯码的包装数量与出库药品的包装数量不一致。';
	        } else {
	          errorMessage = '当前追溯码的药品信息与需要出库的药品信息不一致！';
	        }
	        
	        row.validationResult = {
	          type: 'error',
	          message: errorMessage,
	          drugNameFromGetSomeWare: drugNameFromGetSomeWare,
	          pacCntFromGetSomeWare: pacCntFromGetSomeWare,
	          drugNameFromOuterMedicine: outerDrugName,
	          pacCntFromOuterMedicine: outerPacCnt,
	          drugNameFromCurrentRow: currentRowDrugName,
	          availableQtyFromCurrentRow: currentRowAvailableQty
	        };
	        this.enableConfirmButton = false;
	        console.log('验证失败，禁用确定按钮');
	      }
	    }
	    
	    // 设置验证结果用于显示
	    this.traceCodeValidationResult = {
	      drugName,
	      prepnSpec,
	      pacCnt: pacCntFromTraceCode,
	      approvalLicenceNo,
	      expireDate,
	      msfxDetailResult: traceCodeData
	    };
	    
	  } catch (error) {
	    console.error('追溯码验证失败:', error);
	    
	    row.validationStatus = 'error';
	    row.validationResult = {
	      type: 'error',
	      message: error.message || '追溯码验证失败',
	      drugNameFromGetSomeWare: null,
	      pacCntFromGetSomeWare: null,
	      drugNameFromOuterMedicine: this.currentTraceMedicine?.drugName || '',
	      pacCntFromOuterMedicine: this.currentTraceMedicine?.pacCnt || 1,
	      drugNameFromCurrentRow: row.drugName,
	      availableQtyFromCurrentRow: row.availableQty
	    };
	    
	    this.traceCodeValidationResult = null;
	    this.enableConfirmButton = false;
	  } finally {
	    row.isVerifying = false;
	    this.currentValidatingRowIndex = -1;
	    
	    // 最后检查所有追溯码的验证状态
	    this.checkAllTraceCodesValidation();
	  }
	},
	
	/**
	 * 处理当前出库成本变化
	 */
	async handleCurrentOutCostChange(value, row, index) {
	  if (value === undefined || value === null || isNaN(value) || value < 0) {
	    row.currentOutCost = 0;
	    this.calculateRowAmounts(row);
	    this.calculateTotals(); // 修复：改为 calculateTotals
	    return;
	  }
	  const costValue = parseFloat(value) || 0;
	  row.currentOutCost = costValue;
	  
	  // 根据加成方式计算零售价
	  if (row.drugId && row.markUpId !== undefined) {
	    await this.calculateRetailPriceByMarkUp(row, costValue);
	  }
	  this.calculateRowAmounts(row);
	  this.calculateTotals(); // 修复：改为 calculateTotals
	},
	
	calculateTotals() {
	  // computed 属性会自动计算，无需额外操作
	  // 但为了确保视图更新，可以触发强制更新
	  this.$forceUpdate();
	},
	
	/**
	 * 当前出库成本输入框失去焦点
	 */
	handleCurrentOutCostBlur(event, row, index) {
	  if (row.currentOutCost === undefined || row.currentOutCost === null || isNaN(row.currentOutCost)) {
	    row.currentOutCost = 0;
	  }
	  this.calculateRowAmounts(row);
	  this.calculateTotals(); // 修复：改为 calculateTotals
	},
	
	/**
	 * 根据加成方式计算零售价（仅更新当前出库零售）
	 */
	async calculateRetailPriceByMarkUp(row, costValue) {
	  const markUpId = row.markUpId || 1;
	  const purcType = row.stockType || 2;
	  const drugId = row.drugId;
	  const quantity = parseFloat(row.outQuantity) || 1;
	  
	  try {
	    if (markUpId === 4) {
	      // 不加成：零售价 = 成本
	      row.currentOutSale = costValue * quantity;
	      row.markUpAmount = 0;
	      row.markUpRatio = 0;
	      return;
	    }
	    
	    const response = await docMarkById({
	      drugId: drugId,
	      costPric: costValue,
	      purcType: purcType,
	      drugType: 1
	    });
	    
	    if (response && response.code === 200 && response.data) {
	      const data = response.data;
	      row.markUpRatio = data.markUpRatio || 0;
	      row.markUpAmount = data.markUpPric || 0;
	      
	      let retailPrice = 0;
	      if (markUpId === 1 || markUpId === 3) {
	        if (purcType === 1) {
	          retailPrice = data.minSalePrice || costValue;
	        } else {
	          retailPrice = data.pacSalePrice || costValue;
	        }
	      } else if (markUpId === 2) {
	        retailPrice = costValue + (data.markUpPric || 0);
	      } else {
	        retailPrice = costValue;
	      }
	      
	      // 只更新当前出库零售，不修改入库零售 (salePric)
	      row.currentOutSale = retailPrice * quantity;
	    } else {
	      row.currentOutSale = costValue * quantity;
	      console.warn('docMarkById 接口异常，使用默认值');
	    }
	  } catch (error) {
	    console.error('计算零售价失败:', error);
	    row.currentOutSale = costValue * quantity;
	  }
	},
	
	// 检查所有追溯码的验证状态
	checkAllTraceCodesValidation() {
	  console.log('检查所有追溯码验证状态');
	  
	  if (!this.traceCodeSupplementList || this.traceCodeSupplementList.length === 0) {
	    console.log('追溯码列表为空');
	    this.enableConfirmButton = false;
	    return false;
	  }
	  
	  // 获取所有已填写追溯码的行
	  const filledRows = this.traceCodeSupplementList.filter(row => 
	    row.traceCode && row.traceCode.trim() !== ''
	  );
	  
	  if (filledRows.length === 0) {
	    console.log('没有已填写的追溯码');
	    this.enableConfirmButton = false;
	    return false;
	  }
	  
	  // 检查所有已填写的追溯码是否都验证通过
	  const allValid = filledRows.every(row => row.validationStatus === 'success');
	  
	  console.log('已填写追溯码数量:', filledRows.length, '全部验证通过:', allValid);
	  
	  this.enableConfirmButton = allValid;
	  return allValid;
	},
	
	// 从字符串中提取数字
	extractNumberFromString(str) {
	  if (!str) return 1;
	  
	  // 使用正则表达式匹配数字
	  const match = str.match(/\d+(\.\d+)?/);
	  if (match) {
	    return parseFloat(match[0]);
	  }
	  
	  return 1;
	},
	
    // 检查是否需要上传追溯码
    async checkNeedUploadTraceCode() {
      console.log('====== 开始详细检查是否需要上传追溯码 ======');
      console.log('当前模式:', this.currentMode);
      console.log('药品列表长度:', this.medicineList.length);
      console.log('完整的medicineList:', JSON.stringify(this.medicineList, null, 2));
      
      const traceCodeItems = [];
      const needUploadDrugs = [];
      
      this.medicineList.forEach((item, index) => {
        console.log(`\n=== 检查第 ${index + 1} 个药品 ===`);
        console.log('完整药品对象:', item);
        console.log('药品所有属性:', Object.keys(item));
        console.log('药品名称:', item.drugName);
        console.log('药品ID:', item.drugId);
        console.log('isBar字段值:', item.isBar, '类型:', typeof item.isBar);
        console.log('isBar === 1?', item.isBar === 1);
        console.log('isBar == 1?', item.isBar == 1);
        console.log('isBar === "1"?', item.isBar === "1");
        console.log('isBar == "1"?', item.isBar == "1");
        console.log('traceCodes:', item.traceCodes);
        console.log('tracCodeJson:', item.tracCodeJson);
        
        // 检查isBar字段是否为1（需要处理字符串"1"的情况）
        const isBarValue = item.isBar;
        const isBarValid = isBarValue === 1 || isBarValue === "1" || isBarValue === true || isBarValue === "true";
        
        console.log('isBar是否有效（启用追溯码）:', isBarValid);
        
        if (isBarValid) {
          console.log(`药品 ${item.drugName} 启用了追溯码`);
          
          // 检查是否有追溯码
          let hasTraceCodes = false;
          let traceCodeCount = 0;
          
          // 1. 检查traceCodes数组
          if (item.traceCodes && Array.isArray(item.traceCodes) && item.traceCodes.length > 0) {
            console.log(`从traceCodes找到 ${item.traceCodes.length} 个追溯码`);
            item.traceCodes.forEach(traceCode => {
              if (traceCode.traceCode) {
                traceCodeItems.push({
                  drugName: item.drugName,
                  traceCode: traceCode.traceCode
                });
                hasTraceCodes = true;
                traceCodeCount++;
              }
            });
          }
          
          // 2. 检查tracCodeJson字段
          if (item.tracCodeJson) {
            console.log('发现tracCodeJson字段:', item.tracCodeJson);
            try {
              const parsedCodes = JSON.parse(item.tracCodeJson);
              console.log('解析tracCodeJson成功:', parsedCodes);
              
              if (Array.isArray(parsedCodes) && parsedCodes.length > 0) {
                console.log(`从tracCodeJson解析到 ${parsedCodes.length} 个追溯码`);
                parsedCodes.forEach(traceCode => {
                  if (traceCode.barcode) {
                    traceCodeItems.push({
                      drugName: item.drugName,
                      traceCode: traceCode.barcode
                    });
                    hasTraceCodes = true;
                    traceCodeCount++;
                  }
                });
              }
            } catch (error) {
              console.error('解析tracCodeJson失败:', error);
            }
          }
          
          if (hasTraceCodes) {
            needUploadDrugs.push({
              drugName: item.drugName,
              drugId: item.drugId,
              traceCodeCount: traceCodeCount
            });
            console.log(`药品 ${item.drugName} 有 ${traceCodeCount} 个追溯码需要上传`);
          } else {
            console.log(`药品 ${item.drugName} 启用了追溯码但未找到追溯码数据`);
          }
        } else {
          console.log(`药品 ${item.drugName} 未启用追溯码 (isBar: ${item.isBar})`);
        }
      });
      
      console.log('\n====== 检查结果 ======');
      console.log('找到的追溯码项目:', traceCodeItems);
      console.log('追溯码项目数量:', traceCodeItems.length);
      console.log('需要上传追溯码的药品:', needUploadDrugs);
      
      const needUpload = traceCodeItems.length > 0;
      this.needUploadTraceCode = needUpload;
      this.needUploadDrugs = needUploadDrugs;
      
      console.log('是否需要上传追溯码:', needUpload);
      console.log('needUploadDrugs已保存到this.needUploadDrugs');
      
      return needUpload;
    },
    
    // 提取追溯码
    async extractTraceCodes() {
      console.log('开始提取追溯码');
      
      const traceCodes = [];
      
      // 遍历药品列表，提取所有追溯码
      this.medicineList.forEach((item, index) => {
        console.log(`提取药品 ${item.drugName} 的追溯码`);
        
        // 从tracCodeJson字段提取追溯码
        if (item.tracCodeJson) {
          try {
            const parsedCodes = JSON.parse(item.tracCodeJson);
            console.log(`药品 ${item.drugName} 的tracCodeJson:`, parsedCodes);
            
            if (Array.isArray(parsedCodes) && parsedCodes.length > 0) {
              parsedCodes.forEach(traceCode => {
                if (traceCode.barcode) {
                  traceCodes.push(traceCode.barcode);
                  console.log(`提取到追溯码: ${traceCode.barcode}`);
                }
              });
            }
          } catch (error) {
            console.error('解析tracCodeJson失败:', error);
          }
        } else if (item.traceCodes && Array.isArray(item.traceCodes) && item.traceCodes.length > 0) {
          // 从traceCodes数组提取追溯码
          console.log(`药品 ${item.drugName} 有 ${item.traceCodes.length} 个追溯码`);
          item.traceCodes.forEach(traceCode => {
            if (traceCode.traceCode) {
              traceCodes.push(traceCode.traceCode);
              console.log(`提取到追溯码: ${traceCode.traceCode}`);
            }
          });
        } else {
          console.log(`药品 ${item.drugName} 没有追溯码数据`);
        }
      });
      
      this.traceCodeString = traceCodes.join(',');
      this.traceCodeCount = traceCodes.length;
      console.log('提取的追溯码:', this.traceCodeString, '数量:', this.traceCodeCount);
    },
    
    // 回退草稿
    async handleRollbackDraft() {
      try {
        this.submitLoading = true;
        
        const response = await toXYFRetnExamine({
          id: this.rowData.id,
          state: 0 // 提交回退状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('回退草稿成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退草稿失败');
        }
      } catch (error) {
        console.error('回退草稿失败:', error);
        this.$message.error('回退草稿失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 回退提交
    async handleRollbackSubmit() {
      try {
        this.submitLoading = true;
        
        const response = await toXYFRetnExamine({
          id: this.rowData.id,
          state: 2 // 审核回退状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('回退提交成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退提交失败');
        }
      } catch (error) {
        console.error('回退提交失败:', error);
        this.$message.error('回退提交失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 打印
    handlePrint() {
      this.$message.info('打印功能待实现');
    },
    
    // 截图保存
    handleScreenshot() {
      this.$message.info('截图保存功能待实现');
    },
    
    // 关闭对话框
    handleClose() {
      this.$emit('close');
    },
	
	// 处理追溯码按钮点击
	handleTraceCode(row, index) {
	  console.log('打开追溯码补录模态框，药品行:', row);
	  this.currentTraceMedicine = row;
	  this.traceCodeDialogTitle = `出库追溯码补录 - ${row.drugName}`;
	  
	  // 初始化追溯码补录列表
	  this.initTraceCodeSupplementList(row);
	  
	  // 打开追溯码补录模态框
	  this.traceCodeSupplementDialogVisible = true;
	},
	
	// 初始化追溯码补录列表
	initTraceCodeSupplementList(row) {
	  console.log('初始化追溯码补录列表，药品行信息:', row);
	  
	  // 保存当前药品信息
	  this.currentTraceMedicine = row;
	  
	  // 获取外部药品的包装数量
	  const outerPacCnt = row.pacCnt || 1;
	  
	  // 清空现有的追溯码列表
	  this.traceCodeSupplementList = [];
	  
	  // 获取出库数量
	  const outQuantity = parseInt(row.outQuantity) || 0;
	  console.log('出库数量:', outQuantity, '包装数量:', outerPacCnt);
	  
	  // 获取药品信息
	  const drugInfo = {
	    drugName: row.drugName || '',
	    spec: row.drugSpec || '',
	    pacCnt: outerPacCnt,
	    manufacturer: row.prodentpName || '',
	    batchNo: row.manuLotnum || '',
	    produceDate: this.formatDate(row.manuDate) || '',
	    expireDate: this.formatDate(row.expyDate) || ''
	  };
	  
	  console.log('药品信息:', drugInfo);
	  
	  // 如果药品行已有追溯码列表，则使用已有的
	  if (row.traceCodes && row.traceCodes.length > 0) {
	    console.log('使用已有的追溯码列表，数量:', row.traceCodes.length);
	    this.traceCodeSupplementList = row.traceCodes.map(traceCode => ({
	      id: traceCode.id || Date.now() + Math.random(),
	      traceCode: traceCode.traceCode || '',
	      drugName: drugInfo.drugName,
	      spec: drugInfo.spec,
	      availableQty: outerPacCnt, // 关键修改：使用外部药品的包装数量
	      manufacturer: drugInfo.manufacturer,
	      batchNo: drugInfo.batchNo,
	      produceDate: drugInfo.produceDate,
	      expireDate: drugInfo.expireDate,
	      remark: traceCode.remark || '',
	      validationStatus: 'pending'
	    }));
	  } else {
	    console.log('初始化新的追溯码列表');
	    // 否则初始化新的追溯码列表
	    // 根据出库数量初始化对应数量的追溯码
	    if (outQuantity > 0) {
	      for (let i = 0; i < outQuantity; i++) {
	        this.traceCodeSupplementList.push({
	          id: Date.now() + i + Math.random(),
	          traceCode: '',
	          drugName: drugInfo.drugName,
	          spec: drugInfo.spec,
	          availableQty: outerPacCnt, // 关键修改：使用外部药品的包装数量
	          manufacturer: drugInfo.manufacturer,
	          batchNo: drugInfo.batchNo,
	          produceDate: drugInfo.produceDate,
	          expireDate: drugInfo.expireDate,
	          remark: '',
	          validationStatus: 'pending'
	        });
	      }
	    }
	  }
	  
	  console.log('初始化完成的追溯码补录列表:', this.traceCodeSupplementList);
	},
	
	// 处理扫码输入
	handleScanInput() {
	  if (!this.scanInput.trim()) {
	    this.$message.warning('请输入追溯码');
	    return;
	  }
	  
	  const traceCode = this.scanInput.trim();
	  
	  // 检查是否已存在相同的追溯码
	  const exists = this.traceCodeList.some(item => item.traceCode === traceCode);
	  if (exists) {
	    this.$message.warning('该追溯码已存在');
	    this.scanInput = '';
	    return;
	  }
	  
	  // 找到第一个空的追溯码位置
	  const emptyIndex = this.traceCodeList.findIndex(item => !item.traceCode);
	  if (emptyIndex !== -1) {
	    // 填充到空位置
	    this.traceCodeList[emptyIndex].traceCode = traceCode;
	    this.$set(this.traceCodeList, emptyIndex, this.traceCodeList[emptyIndex]);
	  } else {
	    // 添加新行
	    this.traceCodeList.push({
	      id: Date.now(),
	      traceCode: traceCode,
	      availableQty: 1,
	      remark: ''
	    });
	  }
	  
	  this.$message.success('追溯码添加成功');
	  this.scanInput = '';
	},
	
	// 获取验证标题
	getValidationTitle() {
	  if (this.currentValidatingRowIndex === -1) {
	    return '追溯码验证结果';
	  }
	  
	  const row = this.traceCodeSupplementList[this.currentValidatingRowIndex];
	  if (!row || !row.validationResult) {
	    return '追溯码验证结果';
	  }
	  
	  switch (row.validationResult.type) {
	    case 'success':
	      return '追溯码验证成功';
	    case 'error':
	      return '追溯码验证失败';
	    case 'warning':
	      return '药品不存在于本系统';
	    default:
	      return '追溯码验证结果';
	  }
	},
	
	// 获取验证类型
	getValidationType() {
	  if (this.currentValidatingRowIndex === -1) {
	    return 'info';
	  }
	  
	  const row = this.traceCodeSupplementList[this.currentValidatingRowIndex];
	  if (!row || !row.validationResult) {
	    return 'info';
	  }
	  
	  return row.validationResult.type;
	},
	
	// 获取验证结论
	getValidationConclusion() {
	  if (this.currentValidatingRowIndex === -1) {
	    return '';
	  }
	  
	  const row = this.traceCodeSupplementList[this.currentValidatingRowIndex];
	  if (!row || !row.validationResult) {
	    return '';
	  }
	  
	  return row.validationResult.message;
	},
	
	// 获取结论图标
	getConclusionIcon() {
	  if (this.currentValidatingRowIndex === -1) {
	    return 'el-icon-info';
	  }
	  
	  const row = this.traceCodeSupplementList[this.currentValidatingRowIndex];
	  if (!row || !row.validationResult) {
	    return 'el-icon-info';
	  }
	  
	  switch (row.validationResult.type) {
	    case 'success':
	      return 'el-icon-success';
	    case 'error':
	    case 'warning':
	      return 'el-icon-warning';
	    default:
	      return 'el-icon-info';
	  }
	},
	
	// 获取结论样式类
	getConclusionClass() {
	  if (this.currentValidatingRowIndex === -1) {
	    return 'conclusion-info';
	  }
	  
	  const row = this.traceCodeSupplementList[this.currentValidatingRowIndex];
	  if (!row || !row.validationResult) {
	    return 'conclusion-info';
	  }
	  
	  switch (row.validationResult.type) {
	    case 'success':
	      return 'conclusion-success';
	    case 'error':
	      return 'conclusion-error';
	    case 'warning':
	      return 'conclusion-warning';
	    default:
	      return 'conclusion-info';
	  }
	},
	
	// 获取行类名
	getTraceCodeRowClassName({row, rowIndex}) {
	  if (row.validationStatus === 'success') {
	    return 'success-row';
	  } else if (row.validationStatus === 'error') {
	    return 'error-row';
	  } else if (row.validationStatus === 'pending') {
	    return 'pending-row';
	  }
	  return '';
	},
	
	// 清空所有追溯码
	handleClearTraceCode() {
	  this.$confirm('确定要清空所有追溯码吗？', '提示', {
	    type: 'warning'
	  }).then(() => {
	    this.traceCodeList = [];
	    this.$message.success('已清空所有追溯码');
	  }).catch(() => {});
	},
	
	// 导入追溯码
	handleImportTraceCode() {
	  this.$message.info('导入功能开发中');
	},
	
	// 导出追溯码
	handleExportTraceCode() {
	  if (this.traceCodeList.length === 0) {
	    this.$message.warning('没有追溯码可导出');
	    return;
	  }
	  
	  const exportData = this.traceCodeList
	    .filter(item => item.traceCode)
	    .map(item => item.traceCode)
	    .join('\n');
	  
	  const blob = new Blob([exportData], { type: 'text/plain' });
	  const url = window.URL.createObjectURL(blob);
	  const a = document.createElement('a');
	  a.href = url;
	  a.download = `追溯码_${this.currentTraceMedicine.drugName}_${new Date().getTime()}.txt`;
	  document.body.appendChild(a);
	  a.click();
	  document.body.removeChild(a);
	  window.URL.revokeObjectURL(url);
	  
	  this.$message.success('追溯码导出成功');
	},
	
	// 验证追溯码
	validateTraceCode(row) {
	  if (!row.traceCode) {
	    return;
	  }
	  
	  // 检查追溯码格式（20位数字或字母）
	  const traceCodeRegex = /^[A-Za-z0-9]{20}$/;
	  if (!traceCodeRegex.test(row.traceCode)) {
	    this.$message.warning('追溯码应为20位数字或字母组合');
	    row.traceCode = '';
	  }
	  
	  // 检查是否重复
	  const duplicates = this.traceCodeList.filter(item => 
	    item.traceCode === row.traceCode && item.id !== row.id
	  );
	  if (duplicates.length > 0) {
	    this.$message.warning('追溯码重复');
	    row.traceCode = '';
	  }
	},
	
	// 获取最大可用数量
	getMaxAvailableQty(row) {
	  if (!this.currentTraceMedicine || !this.currentTraceMedicine.outQuantity) {
	    return 1;
	  }
	  
	  const outQuantity = parseInt(this.currentTraceMedicine.outQuantity) || 1;
	  return Math.max(1, outQuantity);
	},
	
	// 处理可用数量变化
	handleAvailableQtyChange(row) {
	  if (row.availableQty < 1) {
	    row.availableQty = 1;
	  }
	  
	  const maxQty = this.getMaxAvailableQty(row);
	  if (row.availableQty > maxQty) {
	    row.availableQty = maxQty;
	    this.$message.warning(`可用数量不能超过${maxQty}`);
	  }
	},
	
	// 移除追溯码
	handleRemoveTraceCode(index) {
	  this.$confirm('确定要删除此追溯码吗？', '提示', {
	    type: 'warning'
	  }).then(() => {
	    this.traceCodeList.splice(index, 1);
	    this.$message.success('追溯码已删除');
	  }).catch(() => {});
	},
	
	// 处理追溯码模态框关闭
	handleTraceCodeDialogClose(done) {
	  if (this.traceCodeList.length > 0) {
	    this.$confirm('关闭将丢失已录入的追溯码，是否继续？', '提示', {
	      type: 'warning'
	    }).then(() => {
	      done();
	    }).catch(() => {});
	  } else {
	    done();
	  }
	},
	
	// 取消追溯码录入
	handleCancelTraceCode() {
	  this.handleTraceCodeDialogClose(() => {
	    this.traceCodeDialogVisible = false;
	    this.resetTraceCodeData();
	  });
	},
	
	// 确定追溯码录入
	handleConfirmTraceCode() {
	  if (!this.currentTraceMedicine) {
	    this.$message.error('未找到药品信息');
	    return;
	  }
	  
	  // 验证追溯码数量
	  const validTraceCodes = this.traceCodeList.filter(item => item.traceCode);
	  const outQuantity = parseInt(this.currentTraceMedicine.outQuantity) || 0;
	  
	  if (validTraceCodes.length === 0) {
	    this.$message.warning('请至少录入一个追溯码');
	    return;
	  }
	  
	  if (validTraceCodes.length > outQuantity) {
	    this.$message.warning(`追溯码数量(${validTraceCodes.length})不能超过出库数量(${outQuantity})`);
	    return;
	  }
	  
	  // 保存追溯码到药品行
	  this.currentTraceMedicine.traceCodes = validTraceCodes;
	  
	  this.$message.success(`已成功录入${validTraceCodes.length}个追溯码`);
	  this.traceCodeDialogVisible = false;
	  this.resetTraceCodeData();
	},
	
	// 是否可以确认追溯码
	canConfirmTraceCode() {
	  if (!this.currentTraceMedicine) {
	    return false;
	  }
	  
	  const validTraceCodes = this.traceCodeList.filter(item => item.traceCode);
	  return validTraceCodes.length > 0;
	},
	
	// 重置追溯码数据
	resetTraceCodeData() {
	  this.currentTraceMedicine = null;
	  this.traceCodeList = [];
	  this.scanInput = '';
	},
	
	// 处理添加追溯码
	handleAddSupplementTraceCode() {
	  console.log('添加新的追溯码行');
	  
	  if (!this.currentTraceMedicine) {
	    this.$message.warning('未找到当前药品信息');
	    return;
	  }
	  
	  // 获取外部药品的包装数量
	  const outerPacCnt = this.currentTraceMedicine.pacCnt || 1;
	  
	  // 创建新的追溯码行
	  const newRow = {
	    id: '',
	    traceCode: '',
	    drugName: this.currentTraceMedicine.drugName || '',
	    spec: this.currentTraceMedicine.drugSpec || '',
	    availableQty: outerPacCnt, // 关键修改：使用外部药品的包装数量
	    manufacturer: this.currentTraceMedicine.prodentpName || '',
	    batchNo: this.currentTraceMedicine.manuLotnum || '',
	    produceDate: this.formatDate(this.currentTraceMedicine.manuDate) || '',
	    expireDate: this.formatDate(this.currentTraceMedicine.expyDate) || '',
	    remark: '',
	    validationStatus: 'pending', // 验证状态：pending等待验证, success验证通过, error验证失败
	    validationResult: null, // 验证结果详情
	    isVerifying: false, // 是否正在验证
	    drugInfoFromApi: null, // 从接口获取的药品信息
	    msfxDetailResult: null, // msfxCodeDetail接口返回的完整结果
	    getSomeWareResult: null // getSomeWare接口返回的结果
	  };
	  
	  this.traceCodeSupplementList.push(newRow);
	  console.log('新增追溯码行，可用数量设置为外部药品包装数量:', outerPacCnt, '当前列表长度:', this.traceCodeSupplementList.length);
	  
	  this.$message.success('已添加新的追溯码录入行，请输入追溯码');
	},
	
	// 处理删除追溯码行
	handleDeleteTraceCodeRow(index) {
	  console.log('删除追溯码行，索引:', index);
	  
	  this.traceCodeSupplementList.splice(index, 1);
	  
	  // 重新检查验证状态
	  this.checkAllTraceCodesValidation();
	  
	  this.$message.success('已删除该追溯码');
	},
	
	// 确认追溯码补录
	handleConfirmTraceCodeSupplement() {
	  console.log('确认追溯码补录');
	  
	  // 首先检查是否有追溯码
	  const filledRows = this.traceCodeSupplementList.filter(row => 
	    row.traceCode && row.traceCode.trim() !== ''
	  );
	  
	  if (filledRows.length === 0) {
	    this.$message.warning('请输入至少一个追溯码');
	    return;
	  }
	  
	  // 检查所有追溯码是否都验证通过
	  const allValid = filledRows.every(row => row.validationStatus === 'success');
	  
	  if (!allValid) {
	    this.$message.warning('有追溯码未通过验证，请先完成验证');
	    return;
	  }
	  
	  // 检查追溯码数量是否匹配
	  const enteredCount = filledRows.length;
	  
	  if (this.currentTraceMedicine && enteredCount !== parseInt(this.currentTraceMedicine.outQuantity)) {
	    this.$confirm(`已录入 ${enteredCount} 个追溯码，但药品出库数量为 ${this.currentTraceMedicine.outQuantity}，追溯码数量不匹配，是否继续？`, '提示', {
	      confirmButtonText: '继续',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	      this.saveTraceCodes();
	    }).catch(() => {
	      // 用户取消
	    });
	  } else {
	    this.saveTraceCodes();
	  }
	},
	
	// 保存追溯码
	saveTraceCodes() {
	  if (!this.currentTraceMedicine) {
	    this.$message.error('未找到当前药品信息');
	    return;
	  }
	  
	  const medicineIndex = this.medicineList.findIndex(item => 
	    item.drugId === this.currentTraceMedicine.drugId
	  );
	  
	  if (medicineIndex === -1) {
	    this.$message.error('未在药品列表中找到该药品');
	    return;
	  }
	  
	  const validTraceCodes = this.traceCodeSupplementList
	    .filter(row => row.traceCode && row.traceCode.trim() !== '')
	    .map(row => ({
	      traceCode: row.traceCode.trim(),
	      availableQty: row.availableQty || 1,
	      remark: row.remark || '',
	      validationStatus: row.validationStatus
	    }));
	  
	  console.log('保存追溯码:', validTraceCodes);
	  
	  this.medicineList[medicineIndex].traceCodes = validTraceCodes;
	  
	  if (validTraceCodes.length > 0) {
	    const tracCodeArray = validTraceCodes.map(traceCode => ({
	      barcode: traceCode.traceCode,
	      chgCnt: traceCode.availableQty || 1,
	      manuLotnum: this.currentTraceMedicine.manuLotnum || ''   // 新增：生产批号
	    }));
	    
	    this.medicineList[medicineIndex].tracCodeJson = JSON.stringify(tracCodeArray);
	    console.log('构建的tracCodeJson:', this.medicineList[medicineIndex].tracCodeJson);
	  } else {
	    this.medicineList[medicineIndex].tracCodeJson = '';
	  }
	  
	  this.traceCodeSupplementDialogVisible = false;
	  this.resetTraceCodeSupplement();
	  this.$message.success('追溯码保存成功');
	},
	
	// 重置追溯码补录状态
	resetTraceCodeSupplement() {
	  this.traceCodeSupplementList = [];
	  this.currentTraceMedicine = null;
	  this.traceCodeValidationResult = null;
	  this.traceCodeValidationLoading = false;
	  this.traceCodeValidationVisible = false;
	  this.currentValidatingRowIndex = -1;
	  this.getSomeWareData = null;
	  this.enableConfirmButton = false;
	},
	
	// 重置追溯码补录数据
	resetTraceCodeSupplementData() {
	  this.currentTraceMedicine = null;
	  this.traceCodeSupplementList = [];
	},
	
	// 确认追溯码录入
	async handleConfirmTraceCodeInput() {
	  // 验证必填项
	  if (!this.traceCodeInputForm.drugName || !this.traceCodeInputForm.inboundQty) {
	    this.$message.warning('请填写所有必填项');
	    return;
	  }
	  
	  try {
	    // 从追溯码录入数据中提取药品信息
	    const traceCodeData = this.traceCodeDetailData;
	    const drugInfo = traceCodeData.drugEntBaseDTO || {};
	    const entInfo = traceCodeData.pUserEntDTO || {};
	    const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
	    
	    // 获取药品ID
	    const drugId = this.getSomeWareData ? this.getSomeWareData.id : null;
	    
	    if (!drugId) {
	      this.$message.warning('该药品未存在于系统中，请先添加药品目录');
	      return;
	    }
	    
	    // 验证生产厂家是否存在
	    let manufacturerValid = false;
	    let manufacturerName = '';
	    let manufacturerId = '';
	    
	    if (drugId && this.traceCodeInputForm.approvalLicenceNo) {
	      try {
	        const response = await getCJSomeWare({
	          drugId: drugId,
	          approvalNumber: this.traceCodeInputForm.approvalLicenceNo
	        });
	        
	        if (response && response.code === 200 && response.data) {
	          manufacturerValid = true;
	          manufacturerName = response.data.manufacturer || this.traceCodeInputForm.manufacturer;
	          manufacturerId = response.data.manufacturerId || '';
	        }
	      } catch (error) {
	        console.error('验证生产厂家失败:', error);
	      }
	    }
	    
	    // 从getSomeWareData中获取药品信息
	    const drugInfoFromWare = this.getSomeWareData;
	    console.log('从getSomeWareData获取的药品信息:', drugInfoFromWare);
	    
	    // 构建追溯码列表
	    const traceCodes = [{
	      id: Date.now(),
	      traceCode: this.traceCodeInputForm.traceCode,
	      availableQty: 1,
	      remark: ''
	    }];
	    
	    // 创建新的药品行
	    const newMedicine = {
	      id: Date.now() + Math.random(),
	      drugId: drugId,
	      drugName: drugInfoFromWare.drugName || this.traceCodeInputForm.drugName,
	      outQuantity: this.traceCodeInputForm.inboundQty, // 出库数量
	      stockType: this.traceCodeInputForm.purcType,
	      pacCnt: drugInfoFromWare.pacCnt || this.traceCodeInputForm.pacCnt, // 包装数量
	      manuLotnum: drugInfoFromWare.manuLotnum || this.traceCodeInputForm.manuLotnum,
	      prodentpName: manufacturerValid ? manufacturerName : drugInfoFromWare.manufacturerName || this.traceCodeInputForm.manufacturer,
	      prodentpNameId: manufacturerId || drugInfoFromWare.manufacturerId || '',
	      drugSpec: drugInfoFromWare.drugSpecifications || this.traceCodeInputForm.spec,
	      dosUnt: drugInfoFromWare.dosUnt || '单位',
	      pacUnt: drugInfoFromWare.pacUnt || '包装单位',
	      isBar: drugInfoFromWare.isBar || 1, // 是否启用追溯码
	      traceCodes: traceCodes, // 追溯码列表
	      isLocked: false,
	      isEditing: this.currentMode === 'edit',
	      verified: this.currentMode === 'add',
	      // 从getSomeWareData获取其他字段
	      purcCnt: drugInfoFromWare.purcCnt || 1,
	      purcPric: drugInfoFromWare.purcPric || 0,
	      salePric: drugInfoFromWare.salePric || 0,
	      currentOutCost: 0,
	      currentOutSale: 0,
	      unit: this.traceCodeInputForm.purcType === 1 ? (drugInfoFromWare.dosUnt || '单位') : (drugInfoFromWare.pacUnt || '包装单位'),
	      dugInvyId: drugInfoFromWare.invyId || drugInfoFromWare.dugInvyId || null,
		  invId: drugInfoFromWare.invyId || drugInfoFromWare.dugInvyId || null,
	    };
	    
	    // 计算当前出库成本和零售
	    this.calculateRowAmounts(newMedicine);
	    
	    // 添加到药品列表
	    this.medicineList.push(newMedicine);
	    
	    this.$message.success(`已成功添加药品: ${newMedicine.drugName}`);
	    
	    // 关闭模态框
	    this.traceCodeInputDialogVisible = false;
	    
	  } catch (error) {
	    console.error('添加药品失败:', error);
	    this.$message.error('添加药品失败: ' + error.message);
	  }
	},
	
	// ========== 新增：追溯码快捷录入功能 ==========
	    // 处理追溯码查询
	    async handleQuickSearch() {
	      const traceCode = this.quickTraceCodeInput.trim();
	      if (!traceCode) {
	        this.$message.warning('请扫描或输入追溯码');
	        return;
	      }
	      
	      this.quickSearchLoading = true;
	      try {
	        // 调用码上放心接口解析追溯码
	        const msfxResponse = await msfxCodeDetail({ codes: traceCode });
	        if (!msfxResponse || msfxResponse.code !== 200 || !msfxResponse.data || msfxResponse.data.length === 0) {
	          this.$message.error('未查询到该追溯码的信息');
	          return;
	        }
	        
	        const traceData = msfxResponse.data[0];
	        const drugEntBase = traceData.drugEntBaseDTO || {};
	        const drugName = drugEntBase.physicName || '';
	        if (!drugName) {
	          this.$message.error('无法从追溯码中解析药品名称');
	          return;
	        }
	        
	        // 解析包装数量
	        const prepnSpec = drugEntBase.prepnSpec || '1';
	        const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
	        
	        // 展示确认模态框
	        this.quickDrugInfo = {
	          drugName: drugName,
	          prepnSpec: prepnSpec,
	          pacCnt: pacCnt,
	          manufacturer: drugEntBase.manufacturerName || '--',
	          batchNo: traceData.produceInfoList?.[0]?.batchNo || '--',
	          expireDate: drugEntBase.expireDate || '--'
	        };
	        this.quickTraceCodeDisplay = traceCode;
	        this.traceCodeQuickDialogVisible = true;
	        
	      } catch (error) {
	        console.error('追溯码解析失败:', error);
	        this.$message.error('追溯码解析失败: ' + (error.message || '网络错误'));
	      } finally {
	        this.quickSearchLoading = false;
	      }
	    },
    
    // 在 methods 中添加或替换以下方法
    
    // 辅助：从追溯码详情构建药品信息（包含追溯码数据）
    buildTraceCodeInfo(traceCodeData, traceCode, selectedDrug) {
      const drugEntBase = traceCodeData.drugEntBaseDTO || {};
      const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
      const entInfo = traceCodeData.pUserEntDTO || {};
      
      const drugName = drugEntBase.physicName || '';
      const prepnSpec = drugEntBase.prepnSpec || '1';
      const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
      const manufacturer = entInfo.entName || '';
      const batchNo = produceInfo.batchNo || '';
      const produceDate = produceInfo.produceDateStr || '';
      const expireDate = produceInfo.originalExpireDate || '';
      const approvalLicenceNo = drugEntBase.approvalLicenceNo || '';
      
      const traceCodes = [{
        traceCode: traceCode,
        drugName: drugName,
        manufacturer: manufacturer,
        batchNo: batchNo,
        produceDate: produceDate,
        expireDate: expireDate,
        availableQty: pacCnt,
        approvalLicenceNo: approvalLicenceNo
      }];
      
      // 构建追溯码JSON，增加 manuLotnum 字段
      const tracCodeJson = JSON.stringify([{
        barcode: traceCode,
        chgCnt: pacCnt,
        manuLotnum: batchNo   // 新增：生产批号
      }]);
      
      return {
        traceCodes,
        tracCodeJson,
        drugName,
        pacCnt,
        manufacturer,
        batchNo,
        produceDate,
        expireDate,
        approvalLicenceNo
      };
    },
    
    // 修改 confirmQuickAddDrug 方法
    async confirmQuickAddDrug() {
      if (!this.quickDrugInfo) return;
      
      this.quickAddLoading = true;
      try {
        const traceCode = this.quickTraceCodeDisplay;
        const { drugName, pacCnt } = this.quickDrugInfo;
        
        // 1. 调用 getSomeWare 校验药品是否存在于本地系统
        const someWareRes = await getSomeWare({ drugName, pacCnt });
        if (someWareRes.code !== 200 || !someWareRes.data || someWareRes.data.length === 0) {
          this.$message.error(`当前追溯码 ${traceCode} ，药品不存在于西药库存中！请先去进行采购工作！`);
          this.traceCodeQuickDialogVisible = false;
          return;
        }
        
        const matchedDrugFromSomeWare = someWareRes.data;
        // 注意：getSomeWare 返回的 drugId 是字符串，selectYFtoYKDrug 返回的是数字，比较时统一转字符串
        const drugIdStr = String(matchedDrugFromSomeWare.drugId);
        const drugPacCnt = matchedDrugFromSomeWare.pacCnt;
        const drugIsBar = matchedDrugFromSomeWare.isBar || 0;
        
        // 2. 调用 selectYFtoYKDrug 接口获取当前药库的药品列表进行精确匹配
        const selectDrugParams = {
          pageNum: 1,
          pageSize: 1000,
          drugName: drugName
        };
        const selectDrugRes = await selectYFtoYKDrug(selectDrugParams);
        if (selectDrugRes.code !== 200 || !selectDrugRes.data || !selectDrugRes.data.content) {
          this.$message.error('获取药品列表失败，无法匹配库存药品');
          return;
        }
        
        // 精确匹配：drugId（字符串比较）、pacCnt、isBar
        const matchedDrug = selectDrugRes.data.content.find(item =>
          String(item.drugId) === drugIdStr &&
          item.pacCnt === drugPacCnt &&
          (item.isBar || 0) === drugIsBar
        );
        
        if (!matchedDrug) {
          this.$message.error(`当前追溯码 ${traceCode} ，药品不存在于西药库存中！请先去进行采购工作！`);
          this.traceCodeQuickDialogVisible = false;
          return;
        }
        
        // 3. 调用 msfxCodeDetail 获取追溯码详情（用于填充生产厂家、批号、有效期等）
        const msfxResponse = await msfxCodeDetail({ codes: traceCode });
        if (msfxResponse.code !== 200 || !msfxResponse.data || msfxResponse.data.length === 0) {
          this.$message.error('获取追溯码详情失败');
          return;
        }
        const traceCodeData = msfxResponse.data[0];
        
        // 构建追溯码信息
        const traceInfo = this.buildTraceCodeInfo(traceCodeData, traceCode, matchedDrug);
        
        // 4. 创建新的药品行（包含追溯码）
        const newRow = {
          id: null,
          drugId: matchedDrug.drugId,
          drugName: matchedDrug.drugName,
          purcCnt: matchedDrug.purcCnt || '',
          outQuantity: 1,  // 默认出库数量为1
          stockType: 2,    // 默认包装单位
          pacCnt: matchedDrug.pacCnt || '',
          prodentpName: matchedDrug.prodentpName || '',
          manuLotnum: traceInfo.batchNo || matchedDrug.manuLotnum || '',
          manuDate: traceInfo.produceDate || matchedDrug.manuDate || '',
          expyDate: traceInfo.expireDate || matchedDrug.expyDate || '',
          purcPric: matchedDrug.purcPric || '',
          currentOutCost: 0,
          salePric: matchedDrug.salePric || '',
          currentOutSale: 0,
          drugSpec: matchedDrug.drugSpec || '',
          unit: matchedDrug.pacUnt || '',
          dosUnt: matchedDrug.dosUnt || '',
          pacUnt: matchedDrug.pacUnt || '',
          invyId: matchedDrug.invyId || matchedDrug.dugInvyId || null,
		  dugInvyId: matchedDrug.invyId || matchedDrug.dugInvyId || null,
          prodentpNameId: matchedDrug.prodentpNameId || null,
          isBar: 1,  // 启用追溯码
          traceCodes: traceInfo.traceCodes,
          tracCodeJson: traceInfo.tracCodeJson,
          traceCodeButtonText: `追溯码(1)`,  // 显示数量
          isLocked: false,
          isEditing: this.currentMode === 'edit',
          hasChanged: false,
          checkingStock: false,
          verified: this.currentMode === 'add',
          verificationResult: null,
          originalData: null
        };
        
        // 计算金额
        this.calculateRowAmounts(newRow);
        this.medicineList.push(newRow);
        
        // 5. 自动触发库存验证（验证通过后会自动锁定行，并启用底部按钮）
        const index = this.medicineList.length - 1;
        await this.autoStockCheck(newRow, index, true);
        
        this.$message.success(`已成功添加药品：${newRow.drugName}，追溯码数量：1`);
        this.traceCodeQuickDialogVisible = false;
        this.quickTraceCodeInput = '';
        
      } catch (error) {
        console.error('快捷添加药品失败:', error);
        this.$message.error('添加药品失败: ' + (error.message || '未知错误'));
      } finally {
        this.quickAddLoading = false;
      }
    }
  }
};
</script>
 
<style lang="less" scoped>
.dialog-container {
  height: 70vh;
  overflow-y: auto;
  padding: 0 20px;
 
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 15px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
  }
  
  /deep/ .purchase-info-section {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .supplier-container {
      display: flex;
      align-items: center;
    }
  }
  
  .medicine-detail-section {
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .section-title {
        margin: 0;
        border: none;
        padding: 0;
      }
    }
    
    .search-box {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
    }
    
	.out-quantity-container {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  gap: 8px;
	}
    .pagination-container {
      margin-top: 15px;
      display: flex;
      justify-content: center;
    }
    
    .summary-row {
      margin-top: 20px;
      padding: 15px;
      background-color: #f5f7fa;
      border-radius: 8px;
      display: flex;
      justify-content: flex-end;
      gap: 30px;
      
      .summary-item {
        font-size: 14px;
        color: #606266;
        
        .summary-label {
          font-weight: 500;
        }
        
        .summary-value {
          font-weight: 600;
          color: #409EFF;
          margin-left: 8px;
        }
      }
    }
  }
}
 
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  
  .el-button {
    margin: 0 10px;
  }
}
 
.save-btn {
  color: #67C23A;
}
 
.cancel-btn {
  color: #909399;
}
 
/* 追溯码录入模态框样式 */
.trace-code-dialog .el-dialog__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}
 
.trace-code-dialog .el-dialog__title {
  color: #303133;
  font-weight: 600;
}
 
.dialog-header {
  padding: 10px 0;
}
 
.dialog-title-text {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
 
.trace-code-dialog-content {
  background-color: #fff;
  padding: 20px;
}
 
.function-buttons-section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}
 
.function-button-group {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
 
.left-function-area {
  flex: 1;
  margin-right: 20px;
}
 
.scan-area-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}
 
.scan-input-wrapper {
  display: flex;
  align-items: center;
}
 
.scan-tips {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  display: flex;
  align-items: center;
}
 
.scan-tips i {
  margin-right: 5px;
  color: #409EFF;
}
 
.right-function-area {
  display: flex;
  gap: 10px;
}
 
.function-button-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid #dcdfe6;
}
 
.function-button-item:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}
 
.function-icon {
  font-size: 20px;
  color: #409EFF;
  margin-bottom: 5px;
}
 
.function-text {
  font-size: 12px;
  color: #606266;
}
 
.summary-info-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
 
.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
 
.summary-item:last-child {
  margin-bottom: 0;
}
 
.summary-item .label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}
 
.summary-item .value {
  font-size: 13px;
  color: #303133;
  font-weight: 600;
}
 
.summary-item .value.warning {
  color: #E6A23C;
}
 
.trace-code-table-section {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}
 
.trace-code-table .el-table__header-wrapper th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #303133;
}
 
.trace-code-dialog-footer {
  background-color: #fff;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
 
/* 扫码枪录入区域样式 */
.scan-input-section {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
 
.section-title {
  display: inline-block;
  margin-right: 20px;
  color: #303133;
  font-weight: 600;
}
 
.scan-input-wrapper {
  display: inline-block;
  vertical-align: middle;
}
 
/* 自定义对话框样式 */
/deep/ .addxyk-dialog {
  border-radius: 8px;
  
  .el-dialog__body {
    padding: 20px 0;
    max-height: calc(85vh - 120px);
    overflow: hidden;
  }
  
  .el-dialog__footer {
    padding: 15px 20px;
  }
}
</style>
 
<style>
/* 全局样式，不加scoped */
.xyk-outbound-drug-select-popper .el-select-dropdown__item {
  height: 60px !important;
  font-size: 12px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
 
/* 使用更具体的选择器覆盖默认选中样式 */
.xyk-outbound-drug-select-popper .el-select-dropdown__item.selected,
.xyk-outbound-drug-select-popper .el-select-dropdown__item.is-selected {
  color: #409EFF !important;
  font-weight: 700 !important;
  background-color: #f0f9ff !important;
}
 
/* 鼠标悬停状态 */
.xyk-outbound-drug-select-popper .el-select-dropdown__item:hover {
  background-color: #f5f7fa !important;
}
</style>
 
<style lang="less" scoped>
/deep/ .el-dialog__header {
	padding-bottom: 10px;
	background: linear-gradient(135deg, #ebfaff 0%, #00557f 100%);
	border-bottom: 1px solid #e8e8e8;
	border-radius: 8px;
	}
 
/deep/ .el-dialog__headerbtn .el-dialog__close{
	color: #ffffff;
}
/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
	color: #000042;
	font-weight: bold;
}
/* 追溯码表格行样式 */
.success-row {
  background-color: #f0f9eb !important;
}
 
.error-row {
  background-color: #fef0f0 !important;
}
 
.pending-row {
  background-color: #f4f4f5 !important;
}
 
/* 验证状态样式 */
.validating-status {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409EFF;
}
 
.success-status {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #67C23A;
}
 
.error-status {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #F56C6C;
}
 
.pending-status {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}
 
/* 验证结果区域样式 */
.validation-result-section {
  margin-top: 20px;
}
 
.validation-details {
  margin-top: 10px;
}
 
.validation-details-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #303133;
}
 
.validation-fields {
  margin-top: 10px;
}
 
.validation-field {
  margin-bottom: 8px;
}
 
.field-label {
  font-weight: 600;
  color: #606266;
  margin-right: 5px;
}
 
.field-value {
  color: #333;
  font-weight: 500;
}
 
/* 验证结论样式 */
.validation-conclusion {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}
 
.conclusion-title {
  font-weight: bold;
  margin-bottom: 8px;
  color: #303133;
}
 
.conclusion-content {
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
 
.conclusion-success {
  background-color: #f0f9eb;
  color: #67C23A;
  border: 1px solid #c2e7b0;
}
 
.conclusion-error {
  background-color: #fef0f0;
  color: #F56C6C;
  border: 1px solid #fbc4c4;
}
 
.conclusion-warning {
  background-color: #fdf6ec;
  color: #E6A23C;
  border: 1px solid #faecd8;
}
 
.conclusion-info {
  background-color: #f4f4f5;
  color: #909399;
  border: 1px solid #e9e9eb;
}
 
/* 追溯码模态框样式 */
.trace-code-modal .el-dialog__body {
  padding: 8px !important;
}
 
.trace-code-modal .el-table {
  font-size: 12px;
}
 
.trace-code-modal .el-table__fixed-right {
  z-index: 3;
}
</style>
 
<style lang="less" scoped>
// 进度模态框样式
.progress-dialog {
  .el-dialog {
    border-radius: 8px;
    
    .el-dialog__header {
      background-color: #409EFF;
      padding: 15px 20px;
      
      .el-dialog__title {
        color: white;
        font-weight: 600;
      }
    }
  }
}
 
.progress-dialog-content {
  padding: 20px;
  max-height: 600px;
  overflow-y: auto;
  
  .step-list {
    .step-item {
      display: flex;
      margin-bottom: 20px;
      padding: 15px;
      border-radius: 8px;
      background-color: #f8f9fa;
      transition: all 0.3s;
      
      &.step-active {
        background-color: #ecf5ff;
        border-left: 4px solid #409EFF;
      }
      
      &.step-completed {
        background-color: #f0f9eb;
      }
      
      &.step-error {
        background-color: #fef0f0;
      }
      
      .step-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        
        i {
          font-size: 24px;
        }
        
        .step-number {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #409EFF;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
      }
      
      .step-content {
        flex: 1;
        
        .step-title {
          font-weight: 600;
          margin-bottom: 8px;
          color: #303133;
          font-size: 14px;
        }
        
        .step-description {
          font-size: 12px;
          color: #606266;
          margin-bottom: 10px;
          
          ul {
            margin: 5px 0 0 20px;
            
            li {
              margin-bottom: 3px;
            }
          }
        }
        
        .step-progress {
          margin-top: 10px;
          
          .el-progress {
            width: 80%;
            display: inline-block;
            vertical-align: middle;
          }
          
          .progress-text {
            display: inline-block;
            margin-left: 10px;
            font-size: 12px;
            color: #409EFF;
            font-weight: bold;
          }
        }
        
        .step-complete {
          font-size: 12px;
          color: #67C23A;
          margin-top: 5px;
          display: flex;
          align-items: center;
        }
        
        .step-error {
          font-size: 12px;
          color: #F56C6C;
          margin-top: 5px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  
  .total-progress-section {
    margin-top: 30px;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    
    .total-progress-title {
      font-weight: 600;
      margin-bottom: 10px;
      color: #303133;
    }
    
    .el-progress {
      /deep/ .el-progress-bar__inner {
        transition: width 0.5s ease-in-out;
      }
    }
  }
}

/* 新增追溯码快捷录入区域样式 */
.quick-trace-search {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  
  .el-input-group__append {
    background-color: #409EFF;
    border-color: #409EFF;
    
    .el-button {
      color: #fff;
    }
    
    .el-button:hover {
      background-color: #66b1ff;
    }
  }
}

.quick-trace-dialog {
  .el-dialog {
    border-radius: 8px;
  }
  
  .el-dialog__header {
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
  }
  
  .quick-trace-content {
    padding: 20px;
    
    .el-form-item {
      margin-bottom: 15px;
      
      .el-form-item__label {
        font-weight: 600;
      }
    }
  }
}
</style>